<template>
<div>

    <v-snackbar :top="y === 'top'" v-model="snackbar">
        {{text}}
        <v-btn class="primary--text" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white" class="pt-3">
        <h2 class="dark-grey--text px-2">Organisation Details</h2>
        <v-spacer></v-spacer>
        <v-btn round color="primary" v-if="displayContents('info')||displayContents('application')||displayContents('accounting')" @click="saveInfoChanges">Save Info Changes</v-btn>
    </v-toolbar>

    <v-toolbar v-if="$store.state.currentOrg.org.isPrimaryOrganisation == true" flat color="white">
        <v-tabs div="tabs">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab href="#" v-model="tabsPrimary" v-for="tab in tabsPrimary" :key="tab.name" @click="setActiveTabName(tab.name)">{{ tab.displayName }}</v-tab>
        </v-tabs>
    </v-toolbar>
    <v-toolbar v-if="$store.state.currentOrg.org.isPrimaryOrganisation == false" flat color="white">
        <v-tabs div="tabs">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab href="#" v-model="tabsNotPrimary" v-for="tab in tabsNotPrimary" :key="tab.name" @click="setActiveTabName(tab.name)">{{ tab.displayName }}</v-tab>
        </v-tabs>
    </v-toolbar>

    <div v-if="displayContents('info')">
        <v-flex>
            <v-card flat color="white" class="text-xs-left" style="color: grey">
                <v-card-text text-xs-left>
                    <v-layout wrap align-center>
                        <v-flex xs4 px-3>
                            <v-text-field label="Organisation Name" v-model="organisationDetail.name"></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs2 px-1>
               
              </v-flex> -->

                        <v-flex xs6>
                            <v-layout align-center justify-center>
                                <v-flex xs4 class="text-xs-center">
                                    <v-img contain max-height="150px" :key="key" :src="organisationDetail.logo"></v-img>
                                    <div>
                                        <v-btn color="primary" round depressed @click="$refs.uploader.click()">Upload Logo
                                        </v-btn>
                                        <input ref="uploader" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'logo')" />
                                    </div>
                                </v-flex>

                                <v-flex xs4 class="text-xs-center">
                                    <v-img contain max-height="75px" :key="key" :src="organisationDetail.icon"></v-img>
                                    <div>
                                        <v-btn color="primary" round depressed @click="$refs.uploaderIcon.click()">Upload Icon
                                        </v-btn>
                                        <input ref="uploaderIcon" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'icon')" />
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <span>Custom Login URL:
                                <b>{{ buildUrl({ name: organisationDetail.name }) }}</b></span>
                        </v-flex>

                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">VAT No.:</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-text-field v-model="organisationDetail.vatNo"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Billing Email Address:</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-text-field v-model="organisationDetail.billingEmailAddress"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Sales Email Address:</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-text-field v-model="organisationDetail.salesEmailAddress"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Website URL:</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-text-field v-model="organisationDetail.websiteUrl"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">T's & C's Link:</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-text-field v-model="organisationDetail.termsAndConditionsLink"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">FUP URL:</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-text-field v-model="organisationDetail.fupUrl"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 mt-2>
                            <h2 class="text-xs-center">Customer Support</h2>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Email:</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-text-field type="email" v-model="organisationDetail.customerSupportEmail"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Contact Number:</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-text-field v-model="organisationDetail.customerSupportTelephone"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Whatsapp number:</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-text-field v-model="organisationDetail.customerSupportWhatsapp"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Description (eg operating times etc):</span>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                    <v-textarea v-model="organisationDetail.customerSupportDescription"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 mt-2>
                            <h2 class="text-xs-center">Address Information</h2>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Physical Address Line 1:</span>
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="organisationDetail.physicalAddressLine1"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Physical Address Line 2:</span>
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="organisationDetail.physicalAddressLine2"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Physical Address Line 3:</span>
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="organisationDetail.physicalAddressLine3"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout row wrap>
                                <v-flex xs4 mt-3>
                                    <span class="subheading">Physical Address Line 4:</span>
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="organisationDetail.physicalAddressLine4"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex mt-3>
                            <v-flex xs6>
                                <span class="subheading">Primary Colour:</span>
                            </v-flex>
                            <v-flex>
                                <chromepicker v-model="organisationDetail.primaryColour" />
                            </v-flex>
                        </v-flex>
                        <v-flex>
                            <v-flex xs6 mt-3>
                                <span class="subheading">Secondary Colour:</span>
                            </v-flex>
                            <v-flex>
                                <chromepicker v-model="organisationDetail.secondaryColour" />
                            </v-flex>
                        </v-flex>
                        <v-flex>
                            <v-flex xs6 mt-3>
                                <span class="subheading">Navbar Colour:</span>
                            </v-flex>
                            <v-flex>
                                <chromepicker v-model="organisationDetail.navbarColour" />
                            </v-flex>
                        </v-flex>
                        <v-flex>
                            <v-flex xs6 mt-3>
                                <span class="subheading">Navbar Text Colour:</span>
                            </v-flex>
                            <v-flex>
                                <chromepicker v-model="organisationDetail.navbarTextColour" />
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </div>

    <div v-if="displayContents('agreements')">
        <v-toolbar flat color="white">
            <v-tabs>
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab @click="headerTab=true;footerTab=false;documentTab=false" flat round color="grey">Header</v-tab>
                <v-tab @click="headerTab=false;footerTab=true;documentTab=false" flat round color="grey">Footer</v-tab>
                <v-tab @click="headerTab=false;footerTab=false;documentTab=true" flat round color="grey">Documents</v-tab>
            </v-tabs>
        </v-toolbar>
        <v-card flat v-show="headerTab">
            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-btn round color="primary" class="white--text" @click="saveHeader()">Save Header</v-btn>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" medium @click="showPossibleHeaderFooterFields = true">help</v-icon>
                    </template>
                    <span>Possible fields in .html file</span>
                </v-tooltip>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="unlayer-editor">

                <EmailEditor :min-height="minHeight" ref="headerEditor" v-on:load="headerEditorLoaded" />
            </div>
        </v-card>
        <v-card flat v-show="footerTab">
            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-btn round color="primary" class="white--text" @click="saveFooter()">Save Footer</v-btn>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" medium @click="showPossibleHeaderFooterFields = true">help</v-icon>
                    </template>
                    <span>Possible fields in .html file</span>
                </v-tooltip>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="unlayer-editor">
                <EmailEditor :min-height="minHeight" ref="footerEditor" v-on:load="footerEditorLoaded" />
            </div>
        </v-card>

        <v-card flat v-show="documentTab">

            <v-layout justify-center align-top wrap>
                <v-flex xs3>
                    <v-list class="scroll-y" style="max-height:450px" flat>
                        <v-list-tile>
                            <v-layout align-center justify-center>
                                <v-list-tile-content align-center>
                                    <h4>Type</h4>
                                </v-list-tile-content>

                            </v-layout>
                        </v-list-tile>

                        <template v-for="(item) in [
                  'End User Agreement',
                  'Terms & Conditions',
                  'Privacy Policy',
                  'B2B Agreement',
                  'Reseller Agreement',
                  'Installation'
                ]">
                            <v-list-tile :key="item" style="cursor: pointer">
                                <v-layout align-center justify-center>
                                    <v-list-tile-content align-center @click="setSelectedAgreement(item)">
                                        <h3 :style="{color:$store.state.currentOrg.org.primaryColour}" v-if="selectedAgreement.type==item">{{item}}</h3>
                                        <v-list-tile-title v-else>{{item}}</v-list-tile-title>

                                    </v-list-tile-content>
                                </v-layout>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-flex>
                <v-flex xs9>
                    <v-layout>
                        <v-flex xs6 mx-1 :key="keyAgreement">
                            <v-text-field v-model="selectedAgreement.name" label="Document Name"></v-text-field>
                        </v-flex>
                        <v-flex xs4 mx-1 :key="keyAgreement">
                            <v-icon v-if="addAgreement&&selectedAgreement.content" color="blue" @click="saveNewAgreement()">save</v-icon>
                            <v-icon v-if="!addAgreement && selectedAgreement && selectedAgreement.id" color="blue" @click="updateAgreement()">save</v-icon>
                            <v-icon v-if="!addAgreement && selectedAgreement && selectedAgreement.id" color="red" @click="deleteAgreement()">delete</v-icon>
                            <v-icon v-if="!addAgreement && selectedAgreement && selectedAgreement.id && !downloading" @click="downloadPdf()">download</v-icon>
                            <v-btn v-if="downloading" round disabled>
                                <span>Downloading</span>
                                <v-progress-circular size="20" indeterminate color="white"></v-progress-circular>
                            </v-btn>

                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs6 :key="keyAgreement">
                            <v-textarea rows="29" style="overflow-y: auto; max-height: 700" v-model="selectedAgreement.content" placeholder="Markdown content"></v-textarea>
                        </v-flex>
                        <v-flex xs6 :key="keyAgreement">
                            <vue-simple-markdown style="overflow-y: auto; max-height: 70vh" v-if="selectedAgreement.content" class="text-xs-left" :key="selectedAgreement.content" :image="true" :source="selectedAgreement.content"></vue-simple-markdown>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>

        </v-card>
    </div>

    <div v-if="displayContents('users')">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn v-if="$store.state.currentOrg.org.isPrimaryOrganisation" round color="primary" @click="attachContactModal = true">Add Contact to Organisation</v-btn>
            <v-btn v-else round color="primary" @click="addContactModal = true">Add Contact to Organisation</v-btn>
        </v-toolbar>
        <v-data-table :headers="userHeaders" :items="organisationUsers" item-key="id" :rows-per-page-items="[25, 50, 100, 250]" class="elevation-1">
            <template v-slot:items="props">
                <td class="text-xs-center">
                    <v-icon color="red" v-if="props.item.userType !== 'systemAdmin'" @click="removeContactFromOrg(props.item)">remove_circle</v-icon>
                </td>
                <td class="text-xs-center">{{ props.item.contact.name }}</td>
                <td class="text-xs-center">{{ props.item.contact.surname }}</td>
                <td class="text-xs-center">{{ props.item.contact.idNumber }}</td>
                <td class="text-xs-center">
                    <v-select :items="contactTypes" item-value="id" item-text="name" @change="selectContactType(props.item)" v-model="props.item.contactTypeId"></v-select>
                </td>
                <td class="text-xs-center">{{ props.item.userType }}</td>
                <td class="text-xs-center">
                    <v-chip color="primary" class="white--text" v-for="role in props.item.userRoles" :key="role">{{ role }}</v-chip>
                </td>
            </template>
            <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of
                {{ props.itemsLength }}</template>
        </v-data-table>
    </div>

    <div v-if="displayContents('packageSettings')">
        <v-card flat color="white">
            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-btn round color="primary" class="white--text" @click="savePackageSettings()">Save Package Settings</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12>
                        <h3>Service Account Upgrades:</h3>
                    </v-flex>
                    <v-flex xs3 mx-1>
                        <v-switch v-model="organisationDetail.allowImmediatePackageUpgrade" label="Allow immediate package upgrades"></v-switch>
                    </v-flex>
                    <v-flex xs3 mx-2>
                        <v-text-field type="number" min="0" v-model="organisationDetail.upgradeFee" label="Upgrade Fee (optional)"></v-text-field>
                    </v-flex>
                    <v-flex xs3 mx-2 v-if="!organisationDetail.allowImmediatePackageUpgrade">
                        <v-text-field type="number" min="0" v-model="organisationDetail.upgradeNoticeDays" label="Upgrade Notice Period"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <h3>Service Account Downgrades:</h3>
                    </v-flex>
                    <v-flex xs3 mx-2>
                        <v-switch v-model="organisationDetail.allowImmediatePackageDowngrade" label="Allow immediate package downgrades"></v-switch>
                    </v-flex>
                    <v-flex xs3 mx-2>
                        <v-text-field v-model="organisationDetail.downgradeFee" label="Downgrade Fee (optional)"></v-text-field>
                    </v-flex>
                    <v-flex xs3 mx-2 v-if="!organisationDetail.allowImmediatePackageDowngrade">
                        <v-text-field v-model="organisationDetail.downgradeNoticeDays" label="Downgrade Notice Period"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <h3>Service Account Terminations:</h3>
                    </v-flex>
                    <v-flex xs3 mx-2>
                        <v-switch v-model="organisationDetail.allowImmediatePackageTermination" label="Allow immediate Terminations"></v-switch>
                    </v-flex>
                    <v-flex xs3 mx-2>
                        <v-text-field v-model="organisationDetail.earlyTerminationFee" label="Termination Fee (optional)"></v-text-field>
                    </v-flex>
                    <v-flex xs3 mx-2>
                        <v-text-field v-model="organisationDetail.terminationNoticeDays" label="Termination Notice Period"></v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>

    <div v-if="displayContents('api')">
        <v-card flat color="white">
            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <!-- <v-btn color="primary" class="white--text" @click="generateCredentials()" round>Generate new credentials</v-btn>
          <v-btn color="primary" class="white--text" @click="viewApiDocumentation()" round>View API Documentation</v-btn> -->
            </v-toolbar>
            <v-layout justify-center wrap mx-1 my-1 :key="orgKey" v-if="organisationKeys.length > 0">
                <v-flex xs10 mx-1 my-1 v-for="key in organisationKeys" :key="key.id">
                    <v-card>
                        <v-layout wrap justify-center align-center>
                            <v-flex xs10>
                                <v-layout align-center justify-left>
                                    <v-flex xs3><b>API Key: </b> </v-flex>
                                    <v-flex xs8>{{ key.apiKey }}
                                        <v-btn flat v-clipboard:copy="key.apiKey">
                                            <v-icon>content_copy</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout align-center justify-left>
                                    <v-flex xs3><b>Secret Key: </b> </v-flex>
                                    <v-flex xs8>{{ key.secretKey }}
                                        <v-btn flat v-clipboard:copy="key.secretKey">
                                            <v-icon>content_copy</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout align-center justify-left mb-1>
                                    <v-flex xs3><b>Created: </b> </v-flex>
                                    <v-flex xs8>{{ key.createdAt }}</v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs2>
                                <v-icon color="red" @click="deleteKey(key)">delete</v-icon>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-layout justify-center wrap mx-1 my-1 :key="orgKey" v-else>
                <v-flex xs10 mx-1 my-1>
                    <v-card>
                        <v-layout wrap justify-center align-center>
                            <v-flex xs10>
                                <v-layout align-center justify-center>
                                    <v-flex xs12><b style="color: grey">There are currently no active API credentials for this
                                            organisation.</b>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-card>
    </div>

    <div v-if="displayContents('email')" class="mx-0">
        <v-toolbar flat color="white">
            <v-flex xs4>
                <v-select @change="
              showTemplate = '';
              loadEditor();
              fetchEmailTemplates(item.type);
            " :items="emailTypes" label="Template Type" v-model="item.type"></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn round color="primary" class="white--text" @click="newTemplateEditorLoaded();addTemplateModal = true;newItem = {};fileName = ''">Add Email Template</v-btn>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on" medium @click="showPossibleFields = true">help</v-icon>
                </template>
                <span>Possible fields in .html file</span>
            </v-tooltip>
        </v-toolbar>
        <v-divider></v-divider>
        <v-layout>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveEditor()" round>Save</v-btn>
        </v-layout>
        <v-card flat color="white" :class="{
                                  'compact-form-mdAndDown': $vuetify.breakpoint.lgAndDown, 'compact-form-notMdAndDown': !$vuetify.breakpoint.lgAndDown,
                                }" class="mx-0">

            <v-layout>

                <v-flex xs4 class="mx-0">
                    <v-list>
                        <v-list-tile :id="file.id" name="templateCard" @click="selectTemplate(file.id, file)" v-for="file in emailTemplates" :key="file.id">
                            <v-list-tile-action>

                                <v-checkbox v-if="file.organisationId&&!file.isDefaultTemplate" @change="toggleTemplate(file, file.isSelected)" v-model="file.isSelected"></v-checkbox>
                                <v-icon v-else-if="emailTemplates.filter(x=>x.organisationId!=null&&x.isSelected).length==0" color="blue">check_circle_outline</v-icon>
                                <!-- <v-checkbox
                  v-else
                  disabled
                    @change="toggleTemplate(file, file.isSelected)"
                    :value="true"
                  ></v-checkbox> -->
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <span v-if="!file.organisationId">Default</span>
                                    <span v-else>{{file.fileName}}</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-layout wrap>
                                    <v-icon class="mt-2" v-if="!file.isDefaultTemplate" flat medium color="grey" @click="deleteEmailItem(file)">delete</v-icon>
                                    <a color="primary" @click="fetchUrl(file.emailTemplate, file.fileName)" :download="txtName" :href="htmlUrl">
                                        <v-icon medium class="mt-2" color="grey">cloud_download</v-icon>
                                    </a>
                                </v-layout>

                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                    <!-- <v-flex xs12   v-for="file in emailTemplates" :key="file.id">
            <v-card class="mx-0">
              <div
                style="cursor: pointer"
                class=" mt-2 pt-1 "
                name="templateCard"
                @click="selectTemplate(file.id, file)"
                :id="file.id"
              >
                <v-layout>
                <v-flex xs1>
                  <v-checkbox
                  v-if="!file.organisationId"
                    @change="toggleTemplate(file, file.isSelected)"
                    v-model="file.isSelected"
                  ></v-checkbox>
                  <v-checkbox
                  v-else
                    @change="toggleTemplate(file, file.isSelected)"
                    v-model="file.isSelected"
                  ></v-checkbox>
                  </v-flex>
                  <v-flex xs9>
                   <h3
                            class="grey--text font-weight-light ml-1"
                            style="margin-top:20px; text-align:left;text-overflow: ellipsis; overflow: hidden;">
                            <span v-if="!file.organisationId">Default</span>
                            <span v-else>{{file.fileName}}</span>
                            </h3>
                   </v-flex>
                   <v-flex xs2>
                  <v-card-actions class="align-center justify-end">
                   
                      <v-icon class="mt-2"
                      v-if="!file.isDefaultTemplate"
                      
                      flat medium color="grey" @click="deleteEmailItem(file)"
                        >delete</v-icon
                      >
                    <a
                      color="primary"
                      @click="fetchUrl(file.emailTemplate, file.fileName)"
                      :download="txtName"
                      :href="htmlUrl"
                      ><v-icon medium  class="mt-2" color="grey">cloud_download</v-icon></a
                    >
                  </v-card-actions>
                  </v-flex>
                </v-layout>
              </div>
            </v-card>
          </v-flex> -->
                </v-flex>
                <v-flex xs9 class="pa-0 ma-0">

                    <div :key="keyEditor" class="unlayer-edit-editor" style="width: 100%">

                        <EmailEditor :min-height="minHeight" width="100%" ref="editEditor" />
                    </div>

                </v-flex>
            </v-layout>

        </v-card>
    </div>

    <div v-if="displayContents('application')">
        <v-layout justify-center align-top wrap mt-2>
            <v-flex xs12>
                <h2 class="grey--text">Order Page Settings</h2>
            </v-flex>
            <v-flex xs8>
                <v-layout justify-center align-top wrap class="mt-2">
                    <v-flex xs12 mx-1>
                        <v-card style="color: grey">
                            <v-layout justify-center align-center>
                                <v-flex xs6>
                                    <v-layout justify-left align-center>
                                        <v-flex xs4 mx-1>
                                            <h3 class="grey--text font-weight-light">Order Page Logo: </h3>
                                        </v-flex>
                                        <v-flex xs8>
                                            <v-img contain max-height="100px" :key="key" :src="organisationDetail.orderPageLogo"></v-img>
                                            <div>
                                                <v-btn color="primary" round depressed @click="$refs.uploaderOrderPageLogo.click()">Upload Logo
                                                </v-btn>
                                                <input ref="uploaderOrderPageLogo" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'orderPageLogo')" />
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 mx-3>
                                    <v-text-field hint="Business days" label="Activation Date Notice Period" type="number" v-model="organisationDetail.applicationNoticeDays"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-center align-center>
                                <v-flex xs6 mx-2>
                                    <v-checkbox label="Allow show of interest (outside network areas)" v-model="organisationDetail.allowShowOfInterest"></v-checkbox>
                                </v-flex>
                                <v-flex xs6 mx-2>
                                    <v-text-field hint="Redirect after order is submitted" label="Redirect URL" v-model="organisationDetail.redirectUrl"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-center align-center>
                                <v-flex xs6 mt-3>
                                    <v-layout justify-left>
                                        <v-flex>
                                            <span>Primary Colour:</span>
                                        </v-flex>
                                        <v-flex>
                                            <chromepicker v-model="organisationDetail.orderPrimaryColour" />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 mt-3>
                                    <v-layout justify-left>
                                        <v-flex>
                                            <span class="subheading">Secondary Colour:</span>
                                        </v-flex>
                                        <v-flex>
                                            <chromepicker v-model="organisationDetail.orderSecondaryColour" />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-center align-center>
                                <v-flex xs8 mx-1>
                                    <v-textarea label="Landing Page Message" v-model="organisationDetail.landingPageMessage"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12>
                <h2 class="grey--text">Billing Settings</h2>
            </v-flex>
            <v-flex xs12>
                <v-layout justify-center align-top wrap class="mt-2">
                    <!-- <v-flex xs4 mx-1>
                        <v-card>
                            <h3 class="grey--text text-xs-center">
                                General Settings
                            </h3>
                            <v-card-text>
                                <v-layout justify-left align-center wrap>
                                    <v-flex xs10 mx-1>
                                        <v-checkbox @change="organisationDetail.billIsp= !organisationDetail.billEndCustomerInstall,organisationDetail.enablePaymentGateway=false" label="Bill End Customer" v-model="organisationDetail.billEndCustomerInstall"></v-checkbox>
                                        <v-checkbox @change="organisationDetail.billEndCustomerInstall= !organisationDetail.billIsp, organisationDetail.enablePaymentGateway=false" label="Bill ISP" v-model="billingSettings.billIsp"></v-checkbox>
                                      

                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex> -->

                    <v-flex xs4 mx-1>
                        <v-card>
                            <!-- <h3 class="grey--text text-xs-center">
                    My Data Package Settings
                  </h3> -->
                            <v-card-text>
                                <v-layout justify-left align-center wrap>
                                    <!-- <v-flex xs6 mx-1>
              <v-autocomplete multiple chips label="Allowed Payment Methods" 
            
              :items="['EFT', 'Direct Debit']" v-model="organisationDetail.allowedPaymentMethods"></v-autocomplete>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-text-field label="Cancellation Notice Period" type="number" min="1" max="30" v-model="organisationDetail.cancellationNoticePeriod"></v-text-field>
            </v-flex> -->
                                    <!-- <v-flex xs12 mx-1>
              <h3 class="grey--text text-xs-center">On Order Approval</h3>
            </v-flex> -->
                                    <!-- <v-flex xs10 mx-1>
              <v-checkbox label="Auto invoice prorata package fees" v-model="organisationDetail.autoInvoiceInstallFees"
            ></v-checkbox>
            </v-flex>
            <v-flex xs10 mx-1>
              <v-checkbox :disabled="organisationDetail.allowedPaymentMethods&&!organisationDetail.allowedPaymentMethods.includes('Direct Debit')" label="Email Debit Order Mandate" v-model="organisationDetail.emailDebitOrderMandate"
            ></v-checkbox>
            </v-flex> -->
                                    <v-flex xs12 class="text-xs-center">
                                        <v-layout justify-left align-center>
                                            <v-flex xs4>
                                                <h3 class="grey--text font-weight-light">Package Card Logo: </h3>
                                            </v-flex>
                                            <v-flex xs8>
                                                <v-img contain max-height="100px" :key="key" :src="organisationDetail.packageCardLogo"></v-img>
                                                <div>
                                                    <v-btn color="primary" round depressed @click="$refs.uploaderPackageLogo.click()">Upload Logo
                                                    </v-btn>
                                                    <input ref="uploaderPackageLogo" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'packageLogo')" />
                                                </div>
                                            </v-flex>
                                        </v-layout>

                                    </v-flex>
                                    <v-flex xs12 class="text-xs-center">
                                        <v-layout justify-left align-center>
                                            <v-flex xs4>
                                                <h3 class="grey--text font-weight-light">Package Card Modal Image: </h3>
                                            </v-flex>
                                            <v-flex xs8>
                                                <v-img contain max-height="100px" :key="key" :src="organisationDetail.packageCardModalImage"></v-img>
                                                <div>
                                                    <v-btn color="primary" round depressed @click="$refs.uploaderModalImage.click()">Upload Logo
                                                    </v-btn>
                                                    <input ref="uploaderModalImage" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'modalImage')" />
                                                </div>
                                            </v-flex>
                                        </v-layout>

                                    </v-flex>

                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>

    <div v-if="displayContents('ispOrderSettings')">
        <v-layout justify-center align-top wrap mt-2>
            <v-flex xs12>
                <h2 class="grey--text">Order Page Settings</h2>
            </v-flex>
            <v-flex xs12>
                <v-layout justify-center align-top wrap class="mt-2">
                    <v-flex xs12 mx-1>
                        <v-card style="color: grey">
                            <v-layout justify-center align-center>
                                <v-flex xs6>
                                    <v-layout justify-left align-center>
                                        <v-flex xs6 mx-1>
                                            <h3 style="text-align:left" class="grey--text font-weight-light">Order Page Logo: </h3>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-img contain max-height="100px" :key="key" :src="organisationDetail.orderPageLogo"></v-img>
                                            <div>
                                                <v-btn color="primary" round depressed @click="$refs.uploaderOrderPageLogo.click()">Upload Logo
                                                </v-btn>
                                                <input ref="uploaderOrderPageLogo" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'orderPageLogo')" />
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                            </v-layout>
                            <v-layout justify-center align-center>
                                <v-flex xs6>
                                    <v-layout justify-left align-center>
                                        <v-flex xs6>
                                            <h3 style="text-align:left" class="grey--text font-weight-light">Package Card Logo: </h3>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-img contain max-height="100px" :key="key" :src="organisationDetail.packageCardLogo"></v-img>
                                            <div>
                                                <v-btn color="primary" round depressed @click="$refs.uploaderPackageLogo.click()">Upload Logo
                                                </v-btn>
                                                <input ref="uploaderPackageLogo" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'packageLogo')" />
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-center align-center>
                                <v-flex xs6>
                                    <v-layout justify-left align-center>
                                        <v-flex xs6>
                                            <h3 style="text-align:left" class="grey--text font-weight-light">Package Card Modal Image: </h3>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-img contain max-height="100px" :key="key" :src="organisationDetail.packageCardModalImage"></v-img>
                                            <div>
                                                <v-btn color="primary" round depressed @click="$refs.uploaderModalImage.click()">Upload Logo
                                                </v-btn>
                                                <input ref="uploaderModalImage" class="d-none" type="file" accept="image/*" @input="selectFile($event, 'modalImage')" />
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>

        </v-layout>
    </div>

    <div v-if="displayContents('accounting')">
        <v-layout justify-center wrap>
            <v-flex>
                <v-card flat>
                    <v-card-text>
                        <v-layout align-center wrap justify-center>
                            <!-- <v-flex xs6 class="text-xs-left">
  <h4>Linked Company:</h4>
              </v-flex> -->
                            <v-flex xs6 sm4>
                                <v-autocomplete  ref="tenantId" v-on:blur="$refs['tenantId'].blur()" v-if="billingSettings.accountingSystem == 'Xero'&&accountingCompanies.length>0" :items="accountingCompanies" clearable label="Accounting Company" item-text="tenantName" item-value="tenantId" v-model="billingSettings.accountingId"></v-autocomplete>
                                <v-btn round color="primary" class="white--text" v-else-if="xeroUrl" :href="xeroUrl">Connect to Xero</v-btn>
                                <v-autocomplete v-if="billingSettings.accountingSystem == 'Xero'&&taxTypes.length>0" :items="taxTypes" clearable label="Tax Type" item-text="name" item-value="taxType" v-model="billingSettings.taxType"></v-autocomplete>
                                <v-select label="Billing Day" v-model="billingSettings.billingDay" :items="availableBillingDays"></v-select>
                                <v-checkbox label="Bill ISP Install Fees" v-model="billingSettings.billIsp"></v-checkbox>
                            </v-flex>
                            <!-- <v-flex xs6 class="text-xs-left">
  <h4>Tax Type:</h4>
              </v-flex> -->
    
                            <v-flex xs6 sm4 class="ml-2">
                                <v-autocomplete  ref="packageAccount" v-on:blur="$refs['packageAccount'].blur()" v-if="billingSettings.aggregatePackageBilling" v-model="billingSettings.packageAccount" :items="accountingAccounts" label="Aggregate package sales account" item-text="name" item-value="id" clearable></v-autocomplete>
                                <v-checkbox label="Include Billing day in calculations" v-model="billingSettings.includeBillingDay"></v-checkbox>
                                <v-checkbox label="Aggregate packages into one line item" v-model="billingSettings.aggregatePackageBilling"></v-checkbox>
                            </v-flex>
                            <v-flex xs6 sm4 class="ml-2">
                                <v-select @change="billingSettings.installAccountCode = null" :items="['Item', 'Account']" label="Install Billing Type" v-model="billingSettings.installFeeType"></v-select>
                            </v-flex>
                            <v-flex xs6 sm4 class="ml-2" v-if="billingSettings.accountingSystem == 'SageOne'">
                                <v-autocomplete v-if="billingSettings.installFeeType=='Account'&&accountingAccounts.length>0" :items="accountingAccounts" item-text="name" item-value="id" label="Install Fees Account" v-model="billingSettings.installAccountCode"></v-autocomplete>
                                <v-autocomplete v-else-if="billingSettings.installFeeType=='Item'&&accountingItems.length>0" :items="accountingItems" item-text="name" item-value="id" label="Install Fees Item" v-model="billingSettings.installAccountCode"></v-autocomplete>
                            </v-flex>
                            <v-flex xs6 sm4 class="ml-2" v-else-if="billingSettings.accountingSystem == 'Xero'">
                                <v-autocomplete ref="installFeeType" v-on:blur="$refs['installFeeType'].blur()" v-if="billingSettings.installFeeType=='Account'&&accountingAccounts.length>0" :items="accountingAccounts" item-text="name" item-value="id" label="Install Fees Account" v-model="billingSettings.installAccountCode"></v-autocomplete>
                                <v-autocomplete ref="installFeeType" v-on:blur="$refs['installFeeType'].blur()" v-else-if="billingSettings.installFeeType=='Item'&&accountingItems.length>0" :items="accountingItems" item-text="name" item-value="id" label="Install Fees Item" v-model="billingSettings.installAccountCode"></v-autocomplete>
                            </v-flex>
                            <v-flex xs6 sm4 class="ml-2">
                                <v-select @change="billingSettings.setupAccountCode = null" :items="['Item', 'Account']" label="Setup Billing Type" v-model="billingSettings.setupFeeType"></v-select>
                            </v-flex>
                            <v-flex xs6 sm4 class="ml-2" v-if="billingSettings.accountingSystem == 'SageOne'">
                                <v-autocomplete v-if="billingSettings.setupFeeType=='Account'&&accountingAccounts.length>0" :items="accountingAccounts" item-text="name" item-value="id" label="Setup/Activation Account" v-model="billingSettings.setupAccountCode"></v-autocomplete>
                                <v-autocomplete v-else-if="billingSettings.setupFeeType=='Item'&&accountingItems.length>0" :items="accountingItems" item-text="name" item-value="id" label="Setup/Activation Account" v-model="billingSettings.setupAccountCode"></v-autocomplete>
                            </v-flex>
                            <v-flex xs6 sm4 class="ml-2" v-else-if="billingSettings.accountingSystem == 'Xero'">
                                <v-autocomplete ref="setupFeeType" v-on:blur="$refs['setupFeeType'].blur()" v-if="billingSettings.setupFeeType=='Account'&&accountingAccounts.length>0" :items="accountingAccounts" item-text="name" item-value="id" label="Setup/Activation Account" v-model="billingSettings.setupAccountCode"></v-autocomplete>
                                <v-autocomplete ref="setupFeeType" v-on:blur="$refs['setupFeeType'].blur()" v-else-if="billingSettings.setupFeeType=='Item'&&accountingItems.length>0" :items="accountingItems" item-text="name" item-value="id" label="Setup/Activation Account" v-model="billingSettings.setupAccountCode"></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 v-if="billingSettings.accountingSystem == 'SageOne'">
                                <v-autocomplete ref="taxTypes" v-on:blur="$refs['taxTypes'].blur()" item-text="name" item-value="id" :items="taxTypes" label="Tax Type" v-model="billingSettings.taxType"></v-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>

    <v-dialog persistent v-model="addTemplateModal">
        <v-card flat color="white">
            <v-toolbar color="primary">
                <h1 class="headline white--text">ADD EMAIL TEMPLATE</h1>
                <v-spacer></v-spacer>
                <v-btn v-if="newItem.type&&newItem.name" class="white--text" depressed round color="primary" @click="saveNewTemplate">Save</v-btn>
                <v-btn round depressed color="primary" @click="addTemplateModal = false">
                    <v-icon class="white--text">close</v-icon>
                </v-btn>

            </v-toolbar>
            <v-card-text>
                <v-layout style="text-justify:center">
                    <v-flex xs6 mx-2>
                        <v-select :items="emailTypes" label="Template Type" v-model="newItem.type" @change="setExistingTemplates(newItem.type)"></v-select>
                    </v-flex>
                    <v-flex xs6 mx-2>
                        <v-text-field label="Save Template As" hint=".html is required" v-model="newItem.name"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout v-if="newItem.selectTemplates&&newItem.type" style="text-justify:center">

                    <v-flex xs6 mx-2>
                        <v-checkbox label="Create New Template" v-model="newItem.selectTemplates"></v-checkbox>
                    </v-flex>
                </v-layout>

                <v-layout v-if="!newItem.selectTemplates&&newItem.type" style="text-justify:center">

                    <v-flex xs4 mx-2>
                        <v-checkbox label="Create New Template" v-model="newItem.selectTemplates"></v-checkbox>
                    </v-flex>
                    <v-flex v-if="!newItem.selectTemplates" xs4 mx-2>
                        <v-select :items="existingEmailTemplates" item-value="id" item-text="fileName" label="Select from Existing Templates" v-model="newItem.fileName"></v-select>
                    </v-flex>
                    <v-flex v-if="!newItem.selectTemplates" xs4 mx-2>
                        <v-text-field persistent-hint hint=".html file is required" @click="$refs.file.click()" prepend-icon="attach_file" readonly label="Import Template" v-model="fileName"></v-text-field>
                        <input style="display: none" id="file" @change="loadTextFromFile($event)" ref="file" type="file" />
                    </v-flex>
                </v-layout>
                <v-layout style="text-justify:center">
                    <div class="unlayer-editor">
                        <EmailEditor :min-height="minHeight" ref="newTemplateEditor" v-on:load="newTemplateEditorLoaded" />
                    </div>
                </v-layout>
                <v-layout>
                </v-layout>
            </v-card-text>

        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="showPossibleFields" max-width="750px">
        <v-card flat color="white">
            <v-toolbar color="primary">
                <h1 class="headline white--text">
                    Possible Fields For '{{ item.type }}' E-mail Template
                </h1>
            </v-toolbar>
            <v-card-text>
                <v-layout style="text-justify: center">
                    <v-flex xs6 mx-2>
                        <v-select :items="emailTypes" @change="fetchInfo(item.type)" label="Template Type" v-model="item.type"></v-select>
                    </v-flex>
                </v-layout>
                <v-flex d-flex>
                    <v-layout wrap>
                        <v-flex md4 v-for="item in infoArray" :key="item">
                            <v-card flat>
                                {{ item }}
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn round color="primary" @click="showPossibleFields = false">Cancel</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="showPossibleHeaderFooterFields" max-width="600px">
        <v-card flat color="white">
            <v-toolbar color="primary">
                <h1 class="headline white--text">
                    Possible Fields For Header or Footer Template
                </h1>
            </v-toolbar>
            <v-card-text>
                <v-flex d-flex>
                    <v-layout wrap>
                        <v-flex md6 v-for="item in headerFieldsArray" :key="item">
                            <v-card flat>
                                {{ item }}
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-center>
                    <v-btn round color="primary" @click="showPossibleHeaderFooterFields = false">Cancel</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="attachContactModal" max-width="900px">
        <v-card>
            <v-toolbar flat color="primary">
                <h1 class="headline white--text">ADD CONTACT TO ORGANISATION</h1>
            </v-toolbar>
            <v-layout>
                <v-flex xs6 mx-3>
                    <v-autocomplete ref="userType" v-on:blur="$refs['userType'].blur()" clearable hide-no-data flat color="primary" v-model="contact.userType" :items="userTypes" item-text="name" item-value="id" label="*Select User Type" class="pt-4" persistent-hint></v-autocomplete>
                </v-flex>
                <v-flex xs6 mx-3>
                    <v-autocomplete ref="contactTypes" v-on:blur="$refs['contactTypes'].blur()" clearable hide-no-data flat color="primary" v-model="contact.contactType" :items="contactTypes" item-text="name" item-value="id" label="*Select Contact Type" class="pt-4" persistent-hint></v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-spacer></v-spacer>
                <v-text-field v-show="contact.userType && contact.contactType" v-model="searchContacts" append-icon="search" label="Search" single-line hide-details max-width="50px" class="pa-3"></v-text-field>
            </v-layout>
            <v-data-table v-if="contact.userType && contact.contactType" :search="searchContacts" :headers="contactHeaders" class="elevation-1" :rows-per-page-items="[10, 25, 50, 100]" :items="allContacts" item-key="id" align-center>
                <template v-slot:items="props">
                    <td class="justify-center layout px-0">
                        <v-icon class="mr-2" v-if="
                  !organisationUsers
                    .map((x) => x.contact.id)
                    .includes(props.item.id)
                " @click="addOrganisationContact(props.item)" color="primary">add_circle_outline</v-icon>
                        <!-- <v-icon small @click="deleteItem(props.item.id)">delete</v-icon> -->
                    </td>
                    <td class="text-xs-center">{{ props.item.name }}</td>
                    <td class="text-xs-center">{{ props.item.surname }}</td>
                    <td class="text-xs-center">{{ props.item.idNumber }}</td>
                    <td class="text-xs-center">{{ props.item.mobileNumber }}</td>
                    <td class="text-xs-center">{{ props.item.telephoneNumber }}</td>
                    <td class="text-xs-center">{{ props.item.emailAddress }}</td>
                </template>
                <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of
                    {{ props.itemsLength }}</template>
            </v-data-table>

            <v-card-actions class="justify-center layout px-0">
                <v-btn color="primary" round @click="attachContactModal = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="addContactModal" max-width="900px">
        <v-card>
            <v-toolbar flat color="primary">
                <h1 class="headline white--text">ADD CONTACT TO ORGANISATION</h1>
            </v-toolbar>
            <v-layout>
                <v-flex xs6 mx-3>
                    <v-autocomplete ref="userType" v-on:blur="$refs['userType'].blur()" clearable hide-no-data flat color="primary" v-model="contact.userType" :items="userTypes" item-text="name" item-value="id" label="*Select User Type" class="pt-4" persistent-hint></v-autocomplete>
                </v-flex>
                <v-flex xs6 mx-3>
                    <v-autocomplete ref="contactTypes" v-on:blur="$refs['contactTypes'].blur()" clearable hide-no-data flat color="primary" v-model="contact.contactType" :items="contactTypes" item-text="name" item-value="id" label="*Select Contact Type" class="pt-4" persistent-hint></v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout justify-center>
                <v-btn v-show="contact.userType && contact.contactType" round color="primary" class="white--text" @click="
              (findByIdNumber = true),
                (findByEmailAddress = false),
                (emailAddress = ''),
                (createNewContact = false)
            ">Find By ID Number</v-btn>
                <v-btn v-show="contact.userType && contact.contactType" round color="primary" class="white--text" @click="
              (findByEmailAddress = true),
                (idNumber = ''),
                (findByIdNumber = false),
                (createNewContact = false)
            ">Find By Email Address</v-btn>
                <v-btn v-show="contact.userType && contact.contactType" round color="primary" class="white--text" @click="
              (createNewContact = true),
                (findByIdNumber = false),
                (findByEmailAddress = false),
                (emailAddress = ''),
                (idNumber = '')
            ">Create New Contact</v-btn>
            </v-layout>
            <v-toolbar flat color="white">
                <v-text-field v-show="findByIdNumber" v-model="idNumber" append-icon="search" label="Please enter ID Number" single-line hide-details max-width="50px" class="pa-3"></v-text-field>
                <v-btn v-show="findByIdNumber" round dark @click="fetchContactByIdNumber()">Search</v-btn>
                <v-text-field v-show="findByEmailAddress" v-model="emailAddress" append-icon="search" label="Please enter Email Address" single-line hide-details max-width="50px" class="pa-3"></v-text-field>
                <v-btn v-show="findByEmailAddress" round dark @click="fetchContactByEmailAddress()">Search</v-btn>
            </v-toolbar>
            <span class="subheading" v-if="noResultsError">No Search Results.</span>
            <v-card hover class="text-xs-center mb-2 mx-2 xs6" v-if="foundContact !== null">
                <v-responsive></v-responsive>
                <v-card-text>
                    <div class="subheading">
                        {{ foundContact.name }} {{ foundContact.surname }}
                    </div>
                    <v-layout>
                        <v-flex xs2 class="text-xs-right">
                            <v-icon small color="grey">smartphone</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                            <div class="grey--text">{{ foundContact.mobileNumber }}</div>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs2 class="text-xs-right">
                            <v-icon small color="grey">email</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                            <div class="grey--text">{{ foundContact.emailAddress }}</div>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs2 class="text-xs-right">
                            <v-icon small color="grey">perm_identity</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                            <div class="grey--text">{{ foundContact.idNumber }}</div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions class="justify-center layout px-0">
                    <v-btn v-if="
                !organisationUsers
                  .map((x) => x.contactId)
                  .includes(foundContact.id)
              " round color="primary" @click="addOrganisationContact(foundContact)">
                        <v-icon medium dark>add_circle_outline</v-icon>Add
                    </v-btn>
                    <!-- <span class="red--text">Contact already associated to organisation.</span> -->
                </v-card-actions>
            </v-card>
            <v-card v-if="createNewContact">
                <v-card-text>
                    <v-container grid-list-xs>
                        <v-layout wrap>
                            <v-flex xs12 sm12 md12>
                                <h3 dark-grey--text>Personal Details</h3>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                                <v-text-field id="addFirstNameId" v-model="contact.name" label="*First Name" persistent-hint required></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                                <v-text-field id="addSurnameId" v-model="contact.surname" label="*Surname" persistent-hint required></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                                <v-text-field id="addIdNumberId" v-model="contact.idNumber" label="*RSA ID Number or Passport Number" persistent-hint></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <h3 dark-grey--text>Contact Details</h3>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                                <v-text-field id="addMobileNumberId" v-model="contact.mobileNumber" label="*Mobile Number" persistent-hint></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                                <v-text-field id="addTelephoneNumberId" v-model="contact.telephoneNumber" label="Telephone Number" persistent-hint></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <h3 dark-grey--text>Login Settings</h3>
                            </v-flex>

                            <v-flex xs12 sm3 md6>
                                <v-text-field id="addEmailAddressId" v-model="contact.emailAddress" prepend-icon="email" label="*Email Address" persistent-hint type="email" v-on:blur="checkEmail"></v-text-field>
                                <span v-if="displayEmailError" class="passWordError">Please make sure that your email address is in the correct
                                    format.</span>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                                <v-text-field id="addPasswordId" prepend-icon="vpn_key" label="*Password" v-model="contact.password" @click:append="show1 = !show1" ref="password" v-on:blur="checkPassword"></v-text-field>
                                <span v-if="displayPasswordError" class="passWordError">The password must contain atleast 8 characters consisting
                                    of atleast 1 uppercase letter, atleast 1 lowercase letter
                                    and atleast 1 number.</span>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-layout justify-center>
                        <v-btn id="contactSaveAddButtonId" color="primary" round @click="saveNewContact">Create Contact</v-btn>
                    </v-layout>
                </v-card-actions>
            </v-card>

            <v-card-actions class="justify-center layout px-0">
                <v-btn color="primary" round @click="
              (addContactModal = false),
                (createNewContact = false),
                (findByIdNumber = false),
                (findByEmailAddress = false),
                (emailAddress = ''),
                (idNumber = ''),
                (contact = {}),
                (noResultsError = false)
            ">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api";
import ContactSearch from "@/components/contactSearchModal.vue";
import {
    Chrome
} from "vue-color";
import {
    PrismEditor
} from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere 
import {
    highlight,
    languages
} from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles
import {
    EmailEditor
} from 'vue-email-editor'

export default {
    components: {
        contactsearchmodal: ContactSearch,
        chromepicker: Chrome,
        PrismEditor,
        EmailEditor,
        // imginput: VImageInput,
    },
    data() {
        return {
            availableBillingDays: ['1st', '7th', '15th', '25th'],
            invoiceDueDate: ['Same Day', '7 Days after Invoice Date', '14 Days after invoice date', 'Last Day of the Month'],
            keyAgreement: 0,
            headerTab: true,
            footerTab: false,
            documentTab: false,
            keyEditor: 0,
            text: "",
            snackbar: false,
            y: "top",
            newItem: {},
            existingEmailTemplates: [],
            accountingCompanies: [],
            xeroUrl: null,
            xeroAuth: null,
            downloading: false,
            minHeight: "750px",
            pdfDownload: "",
            accountingAccounts: [],
            accountingItems: [],
            taxTypes: [],
            addAgreement: false,
            agreement: {},
            compiledMarkdown: "",
            key: 0,
            txtName: "",
            htmlUrl: "",
            headerFieldsArray: [
                "@companyName", "@pageNumber", "@documentName", "@digitalSignature"
            ],
            showHeaderTemplate: "",
            showFooterTemplate: "",
            showTemplate: "",
            selectedId: null,
            fileRules: [(v) => !!v || ".html file is required"],
            infoArray: [],
            showPossibleHeaderFooterFields: false,
            showPossibleFields: false,
            convertFileToHtml: "",
            fileName: "",
            keyReload: 0,
            addTemplateModal: false,
            editTemplateModal: false,
            emailTemplates: [],
            // emailTypes: ["Reset Password", "Service Account Activated", "Service Account Migration", "Service Account Upgrade or Downgrade", "Inform Organisation of Application", "Inform ISP of Application", "Inform Client of Application", "Send OTP", "Notification"],
            emailTypes: [
                'Debit Order Mandate',
                "Inform Organisation of Application",
                "Inform ISP of Application",
                "Inform Client of Application",
                "Reset Password",
                "Inform Organisation of Lead",
                "Inform Client of Lead",
                "Send OTP",
                "Service Account Activated",
                "Service Account Terminated",
                "Notification"
            ],

            emailTemplateHeaders: [{
                    text: "Action",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "File Name",
                    align: "center",
                    value: "fileName",
                },
                {
                    text: "Template Type",
                    align: "center",
                    value: "type",
                },
            ],
            item: {},
            orgKey: 0,
            organisationDetail: null,
            organisationKeys: [],
            organisationAgreements: [],
            selectedAgreement: {},
            addContactModal: false,
            createNewContact: false,
            findByIdNumber: false,
            findByEmailAddress: false,
            idNumber: "",
            emailAddress: "",
            modules: [],
            foreignKey: [],
            initialModules: [],
            userTypes: ["systemUser", "organisationAdmin"],
            allModules: [],
            organisationTypes: [],
            organisationUsers: [],
            foundContact: null,
            primaryColour: "#99cc33",
            secondaryColour: "#c2c7bd",
            orderPrimaryColour: "#99cc33",
            orderSecondaryColour: "#c2c7bd",
            activeTabName: "",
            attachContactModal: false,
            addContactModal: false,
            contact: {},
            contactUserType: null,
            contacts: [],
            allContacts: [],
            searchContacts: "",
            navbarColour: "#7a7676",
            navbarTextColour: "#ffffff",
            newLogoUpload: false,
            noResultsError: false,
            displayEmailError: false,
            displayPasswordError: false,
            file: "",
            contactTypes: [],
            billingSettings: {},
            tabsPrimary: [{
                    name: "info",
                    displayName: "Information"
                },
                {
                    name: "users",
                    displayName: "Users"
                },
                {
                    name: "agreements",
                    displayName: "Agreements"
                },
                {
                    name: "api",
                    displayName: "API"
                },
                // { name: "packageSettings", displayName: "Package Settings" },
                {
                    name: "email",
                    displayName: "Email Templates"
                },
                {
                    name: "application",
                    displayName: "Settings"
                },
                {
                    name: "accounting",
                    displayName: "Accounting Settings"
                },

            ],
            tabsNotPrimary: [{
                    name: "info",
                    displayName: "Information"
                },
                {
                    name: "users",
                    displayName: "Users"
                },
                {
                    name: "api",
                    displayName: "API"
                },
                {
                    name: "ispOrderSettings",
                    displayName: "Order Settings"
                }
            ],
            userHeaders: [{
                    text: "Action",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Name",
                    align: "center",
                    value: "name",
                },
                {
                    text: "Surname",
                    align: "center",
                    value: "surname",
                },
                {
                    text: "ID Number",
                    align: "center",
                    value: "idNumber",
                },
                {
                    text: "Contact Type",
                    align: "center",
                    value: "contactType",
                    width: "120px",
                },
                {
                    text: "User Type",
                    align: "center",
                    value: "userType",
                },
                {
                    text: "User Roles",
                    align: "center",
                    sortable: false,
                },
            ],
            headers: [
                //         {
                //   text: "Action",
                //   align: "center"
                // },
                {
                    text: "Name",
                    align: "center",
                    value: "name",
                },
                {
                    text: "Description",
                    align: "center",
                    value: "description",
                },
            ],
            contactHeaders: [{
                    text: "Actions",
                    align: "center",
                },
                {
                    text: "Name",
                    align: "center",
                    value: "name",
                },
                {
                    text: "Surname",
                    align: "center",
                    value: "surname",
                },
                {
                    text: "ID Number",
                    align: "center",
                    value: "idNumber",
                },
                {
                    text: "Mobile",
                    align: "center",
                    value: "mobileNumber",
                },
                {
                    text: "Telephone",
                    align: "center",
                    value: "telephoneNumber",
                },
                {
                    text: "Email",
                    align: "center",
                    value: "emailAddress",
                },
            ],
        };
    },
    // computed: {
    //         compiledMarkdown: function() {
    //           return Marked(this.organisationDetail.debitOrderMandate, { sanitize: true });
    //         }
    //       },
    watch: {
        "newItem.fileName": {
            immediate: true,
            async handler(value) {
                if (typeof (value) == 'number') {
                    Api().get('/organisationEmailTemplates/ById/' + value).then(response => {
                        if (response.data.emailJson) {
                            this.$refs.newTemplateEditor.loadDesign(JSON.parse(response.data.emailJson))
                        } else {
                            this.$refs.newTemplateEditor.loadDesign({
                                "counters": {
                                    "u_row": 14,
                                    "u_column": 18,
                                    "u_content_menu": 3,
                                    "u_content_text": 14,
                                    "u_content_image": 4,
                                    "u_content_button": 4,
                                    "u_content_social": 1,
                                    "u_content_divider": 6,
                                    "u_content_html": 2
                                },
                                "body": {
                                    "rows": [{
                                        "cells": [1],
                                        "columns": [{
                                            "contents": [{
                                                "type": "text",
                                                "values": {
                                                    "containerPadding": "10px",
                                                    "color": "#000000",
                                                    "textAlign": "left",
                                                    "lineHeight": "140%",
                                                    "linkStyle": {
                                                        "inherit": true,
                                                        "linkColor": "#0000ee",
                                                        "linkHoverColor": "#0000ee",
                                                        "linkUnderline": true,
                                                        "linkHoverUnderline": true
                                                    },
                                                    "_meta": {
                                                        "htmlID": "u_content_text_14",
                                                        "htmlClassNames": "u_content_text"
                                                    },
                                                    "selectable": true,
                                                    "draggable": true,
                                                    "duplicatable": true,
                                                    "deletable": true,
                                                    "text": response.data.emailTemplate
                                                }
                                            }],
                                            "values": {
                                                "backgroundColor": "",
                                                "padding": "0px",
                                                "border": {},
                                                "_meta": {
                                                    "htmlID": "u_column_17",
                                                    "htmlClassNames": "u_column"
                                                }
                                            }
                                        }],
                                        "values": {
                                            "displayCondition": null,
                                            "columns": false,
                                            "backgroundColor": "",
                                            "columnsBackgroundColor": "",
                                            "backgroundImage": {
                                                "url": "",
                                                "fullWidth": true,
                                                "repeat": false,
                                                "center": true,
                                                "cover": false
                                            },
                                            "padding": "0px",
                                            "hideDesktop": false,
                                            "_meta": {
                                                "htmlID": "u_row_14",
                                                "htmlClassNames": "u_row"
                                            },
                                            "selectable": true,
                                            "draggable": true,
                                            "duplicatable": true,
                                            "deletable": true
                                        }
                                    }],
                                    "values": {
                                        "backgroundColor": "#ffffff",
                                        "backgroundImage": {
                                            "url": "",
                                            "fullWidth": true,
                                            "repeat": false,
                                            "center": true,
                                            "cover": false
                                        },
                                        "contentWidth": "500px",
                                        "contentAlign": "center",
                                        "fontFamily": {
                                            "label": "Montserrat",
                                            "value": "'Montserrat',sans-serif",
                                            "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                                            "defaultFont": true
                                        },
                                        "preheaderText": "",
                                        "linkStyle": {
                                            "body": true,
                                            "linkColor": "#0000ee",
                                            "linkHoverColor": "#0000ee",
                                            "linkUnderline": true,
                                            "linkHoverUnderline": true
                                        },
                                        "_meta": {
                                            "htmlID": "u_body",
                                            "htmlClassNames": "u_body"
                                        }
                                    }
                                },
                                "schemaVersion": 5
                            })
                            //this.newTemplateEditorLoaded()
                        }
                    })
                }
            }
        }
    },
    created() {
        this.item.type = "Reset Password";
        this.initialize();
        this.setActiveTabName("info");

    },
    async mounted() {
        this.setActiveTabName("info");
    },
    methods: {
        loadEditor() {
            this.$refs.editEditor.loadDesign({
                "counters": {
                    "u_row": 13,
                    "u_column": 16,
                    "u_content_menu": 3,
                    "u_content_text": 11,
                    "u_content_image": 3,
                    "u_content_button": 4,
                    "u_content_social": 1,
                    "u_content_divider": 6
                },
                "body": {
                    "rows": [],
                    "values": {
                        "backgroundColor": "#ffffff",
                        "backgroundImage": {
                            "url": "",
                            "fullWidth": true,
                            "repeat": false,
                            "center": true,
                            "cover": false
                        },
                        "contentAlign": "center",
                        "fontFamily": {
                            "label": "Montserrat",
                            "value": "'Montserrat',sans-serif",
                            "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                            "defaultFont": true
                        },
                        "preheaderText": "",
                        "linkStyle": {
                            "body": true,
                            "linkColor": "#0000ee",
                            "linkHoverColor": "#0000ee",
                            "linkUnderline": true,
                            "linkHoverUnderline": true
                        },
                    }
                },
                "schemaVersion": 5
            });
        },
        setSelectedAgreement(item) {
            let existing = this.organisationAgreements.filter(x => x.type == item)
            if (existing.length > 0) {
                this.addAgreement = false
                this.selectedAgreement = existing[0]
                this.selectedAgreement.name = existing[0].name
            } else {
                this.selectedAgreement = {}
                this.addAgreement = true;
                this.selectedAgreement.type = item
            }

            this.keyAgreement++

        },
        setExistingTemplates(type) {
            Api()
                .get("/organisationEmailTemplates/byType/" + type)
                .then((response) => {
                    this.existingEmailTemplates = response.data
                })
        },
        newTemplateEditorLoaded() {
            this.$refs.newTemplateEditor.loadDesign({
                "counters": {
                    "u_row": 13,
                    "u_column": 16,
                    "u_content_menu": 3,
                    "u_content_text": 11,
                    "u_content_image": 3,
                    "u_content_button": 4,
                    "u_content_social": 1,
                    "u_content_divider": 6
                },
                "body": {
                    "rows": [],
                    "values": {
                        "backgroundColor": "#ffffff",
                        "backgroundImage": {
                            "url": "",
                            "fullWidth": true,
                            "repeat": false,
                            "center": true,
                            "cover": false
                        },
                        "contentAlign": "center",
                        "fontFamily": {
                            "label": "Montserrat",
                            "value": "'Montserrat',sans-serif",
                            "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                            "defaultFont": true
                        },
                        "preheaderText": "",
                        "linkStyle": {
                            "body": true,
                            "linkColor": "#0000ee",
                            "linkHoverColor": "#0000ee",
                            "linkUnderline": true,
                            "linkHoverUnderline": true
                        },
                    }
                },
                "schemaVersion": 5
            });
        },
        saveEditor() {
            this.$refs.editEditor.exportHtml(
                (data) => {
                    Api().put('/organisationEmailTemplates/' + this.selectedId, {
                        emailTemplate: data.html,
                        emailJson: JSON.stringify(data.design)
                    }).then(response => {
                        this.text = "Successfully Saved!"
                        this.snackbar = true
                        this.keyEditor++
                        this.fetchEmailTemplates(this.item.type)
                        this.clearSelection();
                    })
                })
        },
        footerEditorLoaded() {
            this.$refs.footerEditor.loadDesign(this.showFooterTemplate);
        },
        headerEditorLoaded() {
            this.$refs.headerEditor.loadDesign(this.showHeaderTemplate);
        },
        async saveHeader() {
            this.$refs.headerEditor.exportHtml(
                (data) => {
                    Api().put('/organisation/' + this.$store.state.currentOrg.org.id, {
                        headerTemplate: data.html,
                        headerJson: JSON.stringify(data.design)
                    }).then(async response => {
                        let organisations = this.$store.state.organisations;
                        let currentOrgId = this.$store.state.currentOrg.org.id;
                        let changedOrg = await organisations.find(
                            (x) => x.org.id === currentOrgId
                        );
                        let index = await organisations.indexOf(changedOrg);
                        let currentOrg = {
                            userType: this.$store.state.currentOrg.userType,
                            org: this.$store.state.currentOrg.org,
                        };
                        currentOrg.org.headerTemplate = response.data.headerTemplate
                        currentOrg.org.headerJson = response.data.headerJson
                        organisations[index] = currentOrg;
                        await this.$store.dispatch("setOrganisations", organisations);
                        await this.$store.dispatch("setCurrentOrg", organisations[index]);
                    })

                }
            )

        },
        saveFooter() {
            this.$refs.footerEditor.exportHtml(
                (data) => {
                    Api().put('/organisation/' + this.$store.state.currentOrg.org.id, {
                        footerTemplate: data.html,
                        footerJson: JSON.stringify(data.design)
                    }).then(async response => {
                        let organisations = this.$store.state.organisations;
                        let currentOrgId = this.$store.state.currentOrg.org.id;
                        let changedOrg = await organisations.find(
                            (x) => x.org.id === currentOrgId
                        );
                        let index = await organisations.indexOf(changedOrg);
                        let currentOrg = {
                            userType: this.$store.state.currentOrg.userType,
                            org: this.$store.state.currentOrg.org,
                        };
                        currentOrg.org.footerTemplate = response.data.footerTemplate
                        currentOrg.org.footerJson = response.data.footerJson
                        organisations[index] = currentOrg;
                        await this.$store.dispatch("setOrganisations", organisations);
                        await this.$store.dispatch("setCurrentOrg", organisations[index]);
                    })

                }
            )

        },
        highlighter(code) {
            return highlight(code, languages.js); //returns html
        },
        async fetchSageAccounts() {
            await Api().get('/sageOne/accounts').then(res => {
                let result = res.data.Results.filter(x => x.Category.ID == 1)
                this.accountingAccounts = result.map(x => ({
                    id: x.ID.toString(),
                    name: x.Name
                }))
            })
        },
        async fetchSageItems() {
            await Api().get('/sageOne/items').then(res => {
                this.accountingItems = res.data.Results.map(x => ({
                    id: x.ID.toString(),
                    name: x.Code
                }))
            })
        },
        async fetchSageTaxTypes() {
            await Api().get('/sageOne/taxTypes').then(res => {
                this.taxTypes = res.data.Results.map(x => ({
                    id: x.ID.toString(),
                    name: x.Name
                }))
            })
        },
        getXeroTaxRates() {
            Api().get('/xero/taxRates').then(response => {
                if (response.data && response.data.body) {
                    this.taxTypes = response.data.body.taxRates
                }
            })
        },
        awsUpload(data, type) {
            Api()
                .post("/aws/s3/uploadLogo", {
                    organisationId: this.$store.state.currentOrg.org.id,
                    type: type,
                    data: data
                })
                .then((res) => {
                    console.log(res.data);
                });
        },

        buildUrl(parameters) {
            var qs = "";
            let url = "https://portal.telecoglue.com";
            if (process.env.NODE_ENV == "development") {
                url = "http://localhost:2000";
            }
            for (var key in parameters) {
                var value = parameters[key];
                qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
            }
            if (qs.length > 0) {
                qs = qs.substring(0, qs.length - 1); //chop off last "&"
                url = url + "?" + qs;
            }
            return url;
        },
        selectContactType(item) {
            Api().put("/organisationContact/" + item.id, {
                contactTypeId: item.contactTypeId,
            });
        },
        viewApiDocumentation() {},
        async generateCredentials() {
            Api()
                .post("/organisationKeys", {
                    apiKey: await this.generateKey(),
                    secretKey: await this.generateKey(),
                    isActive: true,
                    isDeleted: false,
                })
                .then((response) => {
                    this.fetchOrganisationApiKeys();
                });
        },
        generateKey() {
            var result = "";
            var characters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < 50; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
            }
            return result;
        },
        deleteKey(key) {
            Api()
                .put("/organisationKeys/" + key.id, {
                    isActive: false,
                    isDeleted: true,
                })
                .then((res) => {
                    this.fetchOrganisationApiKeys();
                });
        },
        fetchEmailTemplates(type) {
            let isSelected = false;
            Api()
                .get("/organisationEmailTemplates/byType/" + type)
                .then((response) => {
                    this.emailTemplates = response.data;
                    for (let i = 0; i < this.emailTemplates.length; i++) {
                        if (this.emailTemplates[i].isSelected === true) {
                            isSelected = true;
                            // let event = this.$store.state.currentOrg.org.logo
                            // this.showTemplate = this.emailTemplates[i].emailTemplate.replace(
                            //   "@companyLogo",event

                            // );
                        }
                    }
                })
                .then((response) => {
                    if (isSelected === false) {
                        for (let j = 0; j < this.emailTemplates.length; j++) {
                            if (this.emailTemplates[j].isDefaultTemplate === true) {
                                // let event = this.$store.state.currentOrg.org.logo
                                // this.showTemplate = this.emailTemplates[
                                //   j
                                // ].emailTemplate.replace(
                                //   "@companyLogo",
                                //   event
                                // );
                                Api()
                                    .put(
                                        "/organisationEmailTemplates/" + this.emailTemplates[j].id, {
                                            isSelected: true,
                                        }
                                    )
                                    .then((response) => {
                                        Api()
                                            .get("/organisationEmailTemplates/byType/" + type)
                                            .then((response) => {
                                                this.emailTemplates = response.data;
                                            });
                                    });
                            }
                        }
                    }
                    console.log(this.emailTemplates.filter(x => x.organisationId && x.isSelected))
                });
        },
        fetchInfo(type) {
            if (type === "Reset Password") {
                this.infoArray = [
                    "@clientEmailAddress",
                    "@clientPassword",
                    "@clientName",
                    "@companyEmailAddress",
                    "@companyName",
                    "@companyLogo",
                ];
            } else if (type === "Service Account Activated") {
                this.infoArray = [
                    "@companyName",
                    "@companyLogo",
                    "@companyWebsite",
                    "@ISPName",
                    "@locationDescription",
                    "@serviceAccountId",
                    "@uploadMbps",
                    "@downloadMbps",
                    "@innerVlan",
                    "@outerVlan",
                    "@companyAddressLine1",
                    "@companyAddressLine2",
                    "@companyAddressLine3",
                    "@circuitNumber",
                ];
            } else if (type === "Service Account Terminated") {
                this.infoArray = [
                    "@companyName",
                    "@companyLogo",
                    "@companyWebsite",
                    "@ISPName",
                    "@locationDescription",
                    "@serviceAccountId",
                    "@companyAddressLine1",
                    "@companyAddressLine2",
                    "@companyAddressLine3",
                    "@circuitNumber",
                ];
            } else if (type === "Service Account Migration") {
                this.infoArray = [
                    "@companyName",
                    "@companyLogo",
                    "@companyWebsite",
                    "@ISPName",
                    "@locationDescription",
                    "@serviceAccountId",
                    "@uploadMbps",
                    "@downloadMbps",
                    "@innerVlan",
                    "@outerVlan",
                    "@companyAddressLine1",
                    "@companyAddressLine2",
                    "@companyAddressLine3",
                    "@circuitNumber",
                ];
            } else if (type === "Service Account Upgrade or Downgrade") {
                this.infoArray = [
                    "@companyName",
                    "@companyLogo",
                    "@companyWebsite",
                    "@ISPName",
                    "@locationDescription",
                    "@serviceAccountId",
                    "@uploadMbps",
                    "@downloadMbps",
                    "@innerVlan",
                    "@outerVlan",
                    "@companyAddressLine1",
                    "@companyAddressLine2",
                    "@companyAddressLine3",
                    "@circuitNumber",
                ];
            } else if (type === "Inform Organisation of Application") {
                this.infoArray = [
                    "@orderId",
                    "@clientName",
                    "@clientEmailAddress",
                    "@clientContactNumber",
                    "@ISPName",
                    "@packageName",
                    "@packageType",
                    "@term",
                    "@recurringPrice",
                    "@onceOffPrice",
                    "@routerInstallFee",
                    "@gtuSelected",
                    "@gtuInstallationFee",
                    "@activationDate",
                    "@estateName",
                    "@unitNumber",
                    "@locationDescription",
                    "@companySalesEmailAddress",
                    "@companyName",
                    "@companyLogo",
                    "@companyWebsite",
                    "@companyTelephoneNumber",
                    "@companyAddressLine1",
                    "@companyAddressLine2",
                    "@companyAddressLine3",
                ];
            } else if (type === "Inform ISP of Application") {
                this.infoArray = [
                    "@orderId",
                    "@clientName",
                    "@clientEmailAddress",
                    "@clientContactNumber",
                    "@ISPName",
                    "@packageName",
                    "@packageType",
                    "@term",
                    "@recurringPrice",
                    "@onceOffPrice",
                    "@routerInstallFee",
                    "@activationDate",
                    "@estateName",
                    "@unitNumber",
                    "@locationDescription",
                    "@billingName",
                    "@billingEmailAddress",
                    "@billlingContactNumber",
                    "@billingAddressLine1",
                    "@billingAddressLine2",
                    "@billingAddressLine3",
                    "@billingAddressSame",
                    "@vatNumber",
                    "@companySalesEmailAddress",
                    "@companyName",
                    "@companyLogo",
                    "@companyWebsite",
                    "@companyTelephoneNumber",
                    "@companyAddressLine1",
                    "@companyAddressLine2",
                    "@companyAddressLine3",
                ];
            } else if (type === "Inform Client of Application") {
                this.infoArray = [
                    "@orderId",
                    "@clientName",
                    "@ISPName",
                    "@packageName",
                    "@packageType",
                    "@term",
                    "@recurringPrice",
                    "@onceOffPrice",
                    "@routerInstallFee",
                    "@gtuSelected",
                    "@gtuInstallationFee",
                    "@activationDate",
                    "@companySalesEmailAddress",
                    "@companyName",
                    "@companyLogo",
                    "@companyWebsite",
                    "@companyTelephoneNumber",
                    "@companyAddressLine1",
                    "@companyAddressLine2",
                    "@companyAddressLine3",
                ];
            } else if (type === "Inform Organisation of Lead") {
                this.infoArray = [
                    "@orderId",
                    "@clientName",
                    "@clientEmailAddress",
                    "@clientContactNumber",
                    "@estateName",
                    "@unitNumber",
                    "@locationDescription",
                    "@companySalesEmailAddress",
                    "@companyName",
                    "@companyLogo",
                    "@companyWebsite",
                    "@companyTelephoneNumber",
                    "@companyAddressLine1",
                    "@companyAddressLine2",
                    "@companyAddressLine3",
                ];
            } else if (type === "Inform Client of Lead") {
                this.infoArray = [
                    "@orderId",
                    "@clientName",
                    "@companySalesEmailAddress",
                    "@companyName",
                    "@companyLogo",
                    "@companyWebsite",
                    "@companyTelephoneNumber",
                    "@companyAddressLine1",
                    "@companyAddressLine2",
                    "@companyAddressLine3",
                ];
            } else if (type === "Send OTP") {
                this.infoArray = [
                    "@otp",
                    "@clientEmailAddress",
                    "@companyEmailAddress",
                    "@companyName",
                    "@companyLogo",
                ];
            } else if (type === "Notification") {
                this.infoArray = [
                    "@ticketId",
                    "@ticketLink",
                    "@companyName",
                    "@companyLogo",
                ];
            }
        },
        deleteEmailItem(item) {
            if (this.authDelete(this.$store.state.currentRoute)) {
                confirm("Are you sure you want to delete this item?") &&
                    Api()
                    .put("/organisationEmailTemplates/" + item.id, {
                        isActive: false,
                        isDeleted: true,
                    })
                    .then((response) => {
                        this.fetchEmailTemplates(item.type);
                    });
            }
        },
        validate() {
            if (
                this.item.fileName != null &&
                this.item.fileName != "" &&
                this.item.type != null &&
                this.item.type != ""
            ) {
                return true;
            }
        },
        addAgreementFunction() {
            this.selectedAgreement = {}
            this.addAgreement = true;
        },
        updateAgreement() {
            Api()
                .put("/agreements/" + this.selectedAgreement.id, this.selectedAgreement)
                .then((res) => {
                    this.selectedAgreement = {};
                    this.fetchAgreements();
                });
        },

        async downloadPdf() {
            this.downloading = true
            this.selectedAgreement.contact = this.$store.state.user.name + ' ' + this.$store.state.user.surname
            await Api()
                .post("/agreements/toPdf",
                    this.selectedAgreement)
                .then(async response => {
                    const linkSource = `data:application/pdf;base64,${response.data}`;
                    const downloadLink = document.createElement("a");
                    const fileName = this.selectedAgreement.name + '.pdf';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.downloading = false
                })
        },
        deleteAgreement() {
            confirm("Are you sure you would like to delete this agreement?") &&
                Api()
                .put("/agreements/" + this.selectedAgreement.id, {
                    isActive: false,
                    isDeleted: true,
                })
                .then((res) => {
                    this.selectedAgreement = {};
                    this.fetchAgreements();
                });
        },
        saveNewAgreement() {
            Api()
                .post("/agreements", this.selectedAgreement)
                .then((res) => {
                    this.fetchAgreements();
                    this.addAgreement = false;
                    this.selectedAgreement = {};
                });
        },
        clearSelection() {
            let elements = document.getElementsByName("templateCard");
            for (let i = 0; i < elements.length; i++) {
                elements[i].style.border = "none";
                elements[i].style.backgroundColor = "white";
            }
        },
        async selectTemplate(id, obj) {
            this.clearSelection();
            if (id != this.selectedId) {
                this.selectedId = id;
                document.getElementById(id).style.backgroundColor = "#e6e6e6";
                document.getElementById(id).style.border =
                    "1px solid " + this.$store.state.currentOrg.org.primaryColour;
                if (obj.emailJson) {
                    await this.$refs.editEditor.loadDesign(JSON.parse(obj.emailJson))
                } else if (obj.emailTemplate) {
                    this.$refs.editEditor.loadDesign({
                        "counters": {
                            "u_row": 14,
                            "u_column": 18,
                            "u_content_menu": 3,
                            "u_content_text": 14,
                            "u_content_image": 4,
                            "u_content_button": 4,
                            "u_content_social": 1,
                            "u_content_divider": 6,
                            "u_content_html": 2
                        },
                        "body": {
                            "rows": [{
                                "cells": [1],
                                "columns": [{
                                    "contents": [{
                                        "type": "text",
                                        "values": {
                                            "containerPadding": "10px",
                                            "color": "#000000",
                                            "textAlign": "left",
                                            "lineHeight": "140%",
                                            "linkStyle": {
                                                "inherit": true,
                                                "linkColor": "#0000ee",
                                                "linkHoverColor": "#0000ee",
                                                "linkUnderline": true,
                                                "linkHoverUnderline": true
                                            },
                                            "_meta": {
                                                "htmlID": "u_content_text_14",
                                                "htmlClassNames": "u_content_text"
                                            },
                                            "selectable": true,
                                            "draggable": true,
                                            "duplicatable": true,
                                            "deletable": true,
                                            "text": obj.emailTemplate
                                        }
                                    }],
                                    "values": {
                                        "backgroundColor": "",
                                        "padding": "0px",
                                        "border": {},
                                        "_meta": {
                                            "htmlID": "u_column_17",
                                            "htmlClassNames": "u_column"
                                        }
                                    }
                                }],
                                "values": {
                                    "displayCondition": null,
                                    "columns": false,
                                    "backgroundColor": "",
                                    "columnsBackgroundColor": "",
                                    "backgroundImage": {
                                        "url": "",
                                        "fullWidth": true,
                                        "repeat": false,
                                        "center": true,
                                        "cover": false
                                    },
                                    "padding": "0px",
                                    "hideDesktop": false,
                                    "_meta": {
                                        "htmlID": "u_row_14",
                                        "htmlClassNames": "u_row"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true
                                }
                            }],
                            "values": {
                                "backgroundColor": "#ffffff",
                                "backgroundImage": {
                                    "url": "",
                                    "fullWidth": true,
                                    "repeat": false,
                                    "center": true,
                                    "cover": false
                                },
                                "contentWidth": "500px",
                                "contentAlign": "center",
                                "fontFamily": {
                                    "label": "Montserrat",
                                    "value": "'Montserrat',sans-serif",
                                    "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                                    "defaultFont": true
                                },
                                "preheaderText": "",
                                "linkStyle": {
                                    "body": true,
                                    "linkColor": "#0000ee",
                                    "linkHoverColor": "#0000ee",
                                    "linkUnderline": true,
                                    "linkHoverUnderline": true
                                },
                                "_meta": {
                                    "htmlID": "u_body",
                                    "htmlClassNames": "u_body"
                                }
                            }
                        },
                        "schemaVersion": 5
                    })

                } else {
                    await this.$refs.editEditor.loadDesign({
                        "counters": {
                            "u_row": 13,
                            "u_column": 16,
                            "u_content_menu": 3,
                            "u_content_text": 11,
                            "u_content_image": 3,
                            "u_content_button": 4,
                            "u_content_social": 1,
                            "u_content_divider": 6
                        },
                        "body": {
                            "rows": [],
                            "values": {
                                "backgroundColor": "#ffffff",
                                "backgroundImage": {
                                    "url": "",
                                    "fullWidth": true,
                                    "repeat": false,
                                    "center": true,
                                    "cover": false
                                },
                                "contentAlign": "center",
                                "fontFamily": {
                                    "label": "Montserrat",
                                    "value": "'Montserrat',sans-serif",
                                    "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                                    "defaultFont": true
                                },
                                "preheaderText": "",
                                "linkStyle": {
                                    "body": true,
                                    "linkColor": "#0000ee",
                                    "linkHoverColor": "#0000ee",
                                    "linkUnderline": true,
                                    "linkHoverUnderline": true
                                },
                            }
                        },
                        "schemaVersion": 5
                    });
                }
                // this.keyEditor++
            } else if (id == this.selectedId) {
                this.selectedId = null;

                await this.$refs.editEditor.loadDesign({
                    "counters": {
                        "u_row": 13,
                        "u_column": 16,
                        "u_content_menu": 3,
                        "u_content_text": 11,
                        "u_content_image": 3,
                        "u_content_button": 4,
                        "u_content_social": 1,
                        "u_content_divider": 6
                    },
                    "body": {
                        "rows": [],
                        "values": {
                            "backgroundColor": "#ffffff",
                            "backgroundImage": {
                                "url": "",
                                "fullWidth": true,
                                "repeat": false,
                                "center": true,
                                "cover": false
                            },
                            "contentAlign": "center",
                            "fontFamily": {
                                "label": "Montserrat",
                                "value": "'Montserrat',sans-serif",
                                "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                                "defaultFont": true
                            },
                            "preheaderText": "",
                            "linkStyle": {
                                "body": true,
                                "linkColor": "#0000ee",
                                "linkHoverColor": "#0000ee",
                                "linkUnderline": true,
                                "linkHoverUnderline": true
                            },
                        }
                    },
                    "schemaVersion": 5
                });
                //this.keyEditor++

            }
        },
        toggleTemplate(file, flag) {
            if (flag == true) {
                Api()
                    .put("/organisationEmailTemplates/" + file.id, {
                        fileName: file.fileName,
                        type: file.type,
                        emailTemplate: file.emailTemplate,
                        organisationId: this.$store.state.currentOrg.org.id,
                        isSelected: true,
                        isActive: true,
                        isDelete: false,
                    })
                    .then((response) => {
                        Api()
                            .put("/organisationEmailTemplates/" + file.type + "/" + file.id, {
                                isSelected: false,
                            })
                            .then((response) => {
                                this.fetchEmailTemplates(file.type);
                            });
                    });
            } else {
                Api()
                    .put("/organisationEmailTemplates/" + file.id, {
                        isSelected: false,
                    })
                    .then((response) => {
                        this.fetchEmailTemplates(file.type);
                    });
            }
        },
        saveNewTemplate() {
            this.$refs.newTemplateEditor.exportHtml(
                (data) => {
                    Api()
                        .post("/organisationEmailTemplates", {
                            fileName: this.newItem.name,
                            type: this.newItem.type,
                            emailTemplate: data.html,
                            emailJson: JSON.stringify(data.design),
                            organisationId: this.$store.state.currentOrg.org.id,
                            isSelected: true,
                            isActive: true,
                            isDelete: false,
                        })
                        .then((response) => {
                            Api()
                                .put(
                                    "/organisationEmailTemplates/" +
                                    this.item.type +
                                    "/" +
                                    response.data.id, {
                                        isSelected: false,
                                    }
                                )
                                .then((response) => {
                                    (this.addTemplateModal = false),
                                    this.fetchEmailTemplates(this.item.type);
                                });
                        });
                })
        },
        async loadTextFromFile(event) {
            var file = event.target.files[0];
            if (file.name.includes(".html")) {
                var reader = await new FileReader();
                reader.onload = () => {
                    this.setResultHtml(reader.result);
                };
                await reader.readAsText(event.target.files[0]);
                reader.onerror = function () {
                    console.log("there are some problems");
                };
                this.item.fileName = file.name;
                this.fileName = file.name;
            } else {
                this.fileName = "";
            }
        },
        setResultHtml(result) {
            this.$refs.newTemplateEditor.loadDesign({
                "counters": {
                    "u_row": 14,
                    "u_column": 18,
                    "u_content_menu": 3,
                    "u_content_text": 14,
                    "u_content_image": 4,
                    "u_content_button": 4,
                    "u_content_social": 1,
                    "u_content_divider": 6,
                    "u_content_html": 2
                },
                "body": {
                    "rows": [{
                        "cells": [1],
                        "columns": [{
                            "contents": [{
                                "type": "text",
                                "values": {
                                    "containerPadding": "10px",
                                    "color": "#000000",
                                    "textAlign": "left",
                                    "lineHeight": "140%",
                                    "linkStyle": {
                                        "inherit": true,
                                        "linkColor": "#0000ee",
                                        "linkHoverColor": "#0000ee",
                                        "linkUnderline": true,
                                        "linkHoverUnderline": true
                                    },
                                    "_meta": {
                                        "htmlID": "u_content_text_14",
                                        "htmlClassNames": "u_content_text"
                                    },
                                    "selectable": true,
                                    "draggable": true,
                                    "duplicatable": true,
                                    "deletable": true,
                                    "text": result
                                }
                            }],
                            "values": {
                                "backgroundColor": "",
                                "padding": "0px",
                                "border": {},
                                "_meta": {
                                    "htmlID": "u_column_17",
                                    "htmlClassNames": "u_column"
                                }
                            }
                        }],
                        "values": {
                            "displayCondition": null,
                            "columns": false,
                            "backgroundColor": "",
                            "columnsBackgroundColor": "",
                            "backgroundImage": {
                                "url": "",
                                "fullWidth": true,
                                "repeat": false,
                                "center": true,
                                "cover": false
                            },
                            "padding": "0px",
                            "hideDesktop": false,
                            "_meta": {
                                "htmlID": "u_row_14",
                                "htmlClassNames": "u_row"
                            },
                            "selectable": true,
                            "draggable": true,
                            "duplicatable": true,
                            "deletable": true
                        }
                    }],
                    "values": {
                        "backgroundColor": "#ffffff",
                        "backgroundImage": {
                            "url": "",
                            "fullWidth": true,
                            "repeat": false,
                            "center": true,
                            "cover": false
                        },
                        "contentWidth": "500px",
                        "contentAlign": "center",
                        "fontFamily": {
                            "label": "Montserrat",
                            "value": "'Montserrat',sans-serif",
                            "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                            "defaultFont": true
                        },
                        "preheaderText": "",
                        "linkStyle": {
                            "body": true,
                            "linkColor": "#0000ee",
                            "linkHoverColor": "#0000ee",
                            "linkUnderline": true,
                            "linkHoverUnderline": true
                        },
                        "_meta": {
                            "htmlID": "u_body",
                            "htmlClassNames": "u_body"
                        }
                    }
                },
                "schemaVersion": 5
            })

            this.item.emailTemplate = result;
        },
        setResultUrl(result) {
            this.item.htmlUrl = result;
        },
        async fetchUrl(html, fileName) {
            var text = html;
            var data = new Blob([text], {
                type: "text/plain"
            });
            var url = window.URL.createObjectURL(data);
            this.htmlUrl = url;
            this.txtName = fileName.replace(
                fileName.substring(fileName.length - 5),
                ".html"
            );
        },
        selectFile(event, type) {
            this.file = event.srcElement.files[0];
            this.readFile(this.file, type);
        },
        async readFile(file, type) {
            var reader = await new FileReader();
            await reader.readAsDataURL(file);
            reader.onload = () => {
                if (type == 'logo') {
                    this.setResultLogo(reader.result);
                } else if (type == 'packageLogo') {
                    this.setResultPackageLogo(reader.result)
                } else if (type == 'modalImage') {
                    this.setResultPackageModalImage(reader.result)
                } else if (type == 'icon') {
                    this.setResultIcon(reader.result)
                } else if (type == 'orderPageLogo') {
                    this.setResultOrderPageLogo(reader.result)
                }
            };
            reader.onerror = function () {
                console.log("there are some problems");
            };
        },
        setResultOrderPageLogo(result) {
            this.awsUpload(result, 'orderPageLogo')
            this.organisationDetail.orderPageLogo = result;
            this.key += 1;
        },
        setResultLogo(result) {
            this.awsUpload(result, 'logo')
            this.organisationDetail.logo = result;
            this.key += 1;
        },
        setResultIcon(result) {
            this.awsUpload(result, 'icon')
            this.organisationDetail.icon = result;
            this.key += 1;
        },
        setResultPackageLogo(result) {
            this.awsUpload(result, 'packageLogo')
            this.organisationDetail.packageCardLogo = result;
            this.key += 1;
        },
        setResultPackageModalImage(result) {
            this.awsUpload(result, 'modalImage')
            this.organisationDetail.packageCardModalImage = result;
            this.key += 1;
        },
        async uploadFile() {
            let organisations = this.$store.state.organisations;
            let currentOrgId = this.$store.state.currentOrg.org.id;

            let changedOrg = await organisations.find(
                (x) => x.org.id === currentOrgId
            );
            let index = await organisations.indexOf(changedOrg);
            if (typeof this.organisationDetail.primaryColour === "object") {
                this.organisationDetail.primaryColour = this.organisationDetail.primaryColour.hex;
            }
            if (typeof this.organisationDetail.secondaryColour === "object") {
                this.organisationDetail.secondaryColour = this.organisationDetail.secondaryColour.hex;
            }
            if (typeof this.organisationDetail.navbarColour === "object") {
                this.organisationDetail.navbarColour = this.organisationDetail.navbarColour.hex;
            }
            if (typeof this.organisationDetail.navbarTextColour === "object") {
                this.organisationDetail.navbarTextColour = this.organisationDetail.navbarTextColour.hex;
            }
            Api()
                .get("/organisation/" + currentOrgId)
                .then(async (response) => {
                    response.data.organisationType = this.$store.state.currentOrg.org.organisationType;
                    response.data.organisationModules = this.$store.state.currentOrg.org.organisationModules;
                    response.data.organisationContacts = this.$store.state.currentOrg.org.organisationContacts;
                    response.data.frontendRoutes = this.$store.state.currentOrg.org.frontendRoutes;
                    response.data.frontendRoutePermissions = this.$store.state.currentOrg.org.frontendRoutePermissions;
                    response.data.permissions = this.$store.state.currentOrg.org.permissions;
                    let currentOrg = {
                        userType: this.$store.state.currentOrg.userType,
                        org: response.data,
                    };
                    organisations[index] = currentOrg;
                    await this.$store.dispatch("setOrganisations", organisations);
                    await this.$store.dispatch("setCurrentOrg", organisations[index]);
                });
        },
        fetchOrgUserRoles() {
            Api()
                .get("/userRole")
                .then((response) => {
                    this.userRole = response.data;
                });
        },
        addOrganisationContact(item) {
            Api()
                .post("/organisationContact", {
                    organisationId: this.$route.params.organisationId,
                    contactId: item.id,
                    userType: this.contact.userType,
                    contactTypeId: this.contact.contactType,
                    isActive: true,
                    isDeleted: false,
                })
                .then((response) => {
                    if (this.contact.userType === "organisationAdmin") {
                        for (let i = 0; i < this.userRole.length; i++) {
                            if (this.userRole[i].isAdmin) {
                                Api().post("/userRoleContact", {
                                    contactId: item.id,
                                    userRoleId: this.userRole[i].id,
                                    isActive: true,
                                    isDeleted: false,
                                });
                            }
                        }
                    }
                    this.fetchOrganisationInfo();
                    this.initialize();
                    this.contact = {};
                    this.idNumber = "";
                    this.emailAddress = "";
                    this.createNewContact = false;
                    this.findByEmailAddress = false;
                    this.findByIdNumber = false;
                    this.foundContact = null;
                    this.attachContactModal = false;
                    this.addContactModal = false;
                });
        },
        fetchContactByIdNumber() {
            Api()
                .get("/contacts/byIdNumber/" + this.idNumber)
                .then((response) => {
                    if (response.data !== "") {
                        this.foundContact = response.data;
                        this.noResultsError = false;
                    } else {
                        this.foundContact = null;
                        this.noResultsError = true;
                    }
                });
        },
        fetchContactByEmailAddress() {
            Api()
                .get("/contacts/byEmail/" + this.emailAddress)
                .then((response) => {
                    if (response.data !== "") {
                        this.foundContact = response.data;
                        this.noResultsError = false;
                    } else {
                        this.foundContact = null;
                        this.noResultsError = true;
                    }
                });
        },
        fetchAllContacts() {
            Api()
                .get("/contacts")
                .then((response) => {
                    this.allContacts = response.data;
                });
        },
        checkPassword() {
            let passReg = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$");
            const match = passReg.test(this.contact.password);
            if (match) {
                this.displayPasswordError = false;
            } else {
                this.displayPasswordError = true;
            }
        },
        checkEmail() {
            let emailReg = new RegExp(
                "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
            );
            // const match = emailReg.test(this.contact.emailAddress)
            match = true;
            if (match) {
                this.displayEmailError = false;
            } else {
                this.displayEmailError = true;
            }
        },
        fetchOrgContacts() {
            this.organisationUsers = [];
            Api()
                .get("/organisationContact")
                .then(async (response) => {
                    let organisationUsers = response.data.filter(function (el) {
                        return el.userType !== "endClient" && !el.contact.isHidden;
                    });
                    this.organisationUsers = await organisationUsers.map((x) => ({
                        id: x.id,
                        contact: x.contact,
                        userRoles: [
                            ...new Set(
                                [
                                    ...new Set(
                                        x.contact.userRoleContacts.filter(
                                            (y) => y.isActive && !y.isDeleted
                                        )
                                    ),
                                ].map((z) => z.userRole.name)
                            ),
                        ],
                        userType: x.userType,
                        contactType: x.contactType,
                    }));

                    //  for (let i = 0; i < organisationUsers.length; i++) {
                    //     if (!response.data[i].contact.isHidden) {
                    //       this.organisationUsers.push({
                    //         id: response.data[i].id,
                    //         contact: response.data[i].contact,
                    //         userRoles: response.data[i].contact.userRoleContacts.filter(
                    //           x => x.isActive && !x.isDeleted
                    //         ),
                    //         userType: response.data[i].userType,
                    //         contactType: response.data[i].contactType
                    //       });
                    //     }
                    //   }
                });
        },
        fetchOrganisationInfo() {
            this.organisationDetail = this.$store.state.currentOrg.org;
            if (this.organisationDetail.primaryColour === null) {
                this.organisationDetail.primaryColour = this.primaryColour;
            }
            if (this.organisationDetail.secondaryColour === null) {
                this.organisationDetail.secondaryColour = this.secondaryColour;
            }
            if (this.organisationDetail.orderPrimaryColour === null) {
                this.organisationDetail.orderPrimaryColour = this.orderPrimaryColour;
            }
            if (this.organisationDetail.orderSecondaryColour === null) {
                this.organisationDetail.orderSecondaryColour = this.orderSecondaryColour;
            }
            if (this.organisationDetail.navbarColour === null) {
                this.organisationDetail.navbarColour = this.navbarColour;
            }
            if (this.organisationDetail.navbarTextColour === null) {
                this.organisationDetail.navbarTextColour = this.navbarTextColour;
            }
            if (this.organisationDetail.headerJson) {
                this.showHeaderTemplate = JSON.parse(this.organisationDetail.headerJson)
            } else {
                this.showHeaderTemplate = {
                    "counters": {
                        "u_row": 13,
                        "u_column": 16,
                        "u_content_menu": 3,
                        "u_content_text": 11,
                        "u_content_image": 3,
                        "u_content_button": 4,
                        "u_content_social": 1,
                        "u_content_divider": 6
                    },
                    "body": {
                        "rows": [],
                        "values": {
                            "backgroundColor": "#ffffff",
                            "backgroundImage": {
                                "url": "",
                                "fullWidth": true,
                                "repeat": false,
                                "center": true,
                                "cover": false
                            },
                            "contentAlign": "center",
                            "fontFamily": {
                                "label": "Montserrat",
                                "value": "'Montserrat',sans-serif",
                                "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                                "defaultFont": true
                            },
                            "preheaderText": "",
                            "linkStyle": {
                                "body": true,
                                "linkColor": "#0000ee",
                                "linkHoverColor": "#0000ee",
                                "linkUnderline": true,
                                "linkHoverUnderline": true
                            },
                        }
                    },
                    "schemaVersion": 5
                }
            }
            if (this.organisationDetail.footerJson) {
                this.showFooterTemplate = JSON.parse(this.organisationDetail.footerJson)
            } else {
                this.showFooterTemplate = {
                    "counters": {
                        "u_row": 13,
                        "u_column": 16,
                        "u_content_menu": 3,
                        "u_content_text": 11,
                        "u_content_image": 3,
                        "u_content_button": 4,
                        "u_content_social": 1,
                        "u_content_divider": 6
                    },
                    "body": {
                        "rows": [],
                        "values": {
                            "backgroundColor": "#ffffff",
                            "backgroundImage": {
                                "url": "",
                                "fullWidth": true,
                                "repeat": false,
                                "center": true,
                                "cover": false
                            },
                            "contentAlign": "center",
                            "fontFamily": {
                                "label": "Montserrat",
                                "value": "'Montserrat',sans-serif",
                                "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                                "defaultFont": true
                            },
                            "preheaderText": "",
                            "linkStyle": {
                                "body": true,
                                "linkColor": "#0000ee",
                                "linkHoverColor": "#0000ee",
                                "linkUnderline": true,
                                "linkHoverUnderline": true
                            },
                        }
                    },
                    "schemaVersion": 5
                }
            }
            if (this.organisationDetail.allowedPaymentMethods) {
                // this.organisationDetail.allowedPaymentMethods = JSON.parse(this.organisationDetail.allowedPaymentMethods)

            } else {
                this.organisationDetail.allowedPaymentMethods = []
            }
            console.log(this.organisationDetail.allowedPaymentMethods)
        },
        savePackageSettings() {
            Api().put("/organisation/" + this.$store.state.currentOrg.org.id, {
                allowImmediatePackageUpgrade: this.organisationDetail
                    .allowImmediatePackageUpgrade,
                allowImmediatePackageDowngrade: this.organisationDetail
                    .allowImmediatePackageDowngrade,
                allowImmediatePackageTermination: this.organisationDetail
                    .allowImmediatePackageTermination,
                terminationHandling: this.organisationDetail.terminationHandling,
                earlyTerminationFee: this.organisationDetail.earlyTerminationFee,
                upgradeFee: this.organisationDetail.upgradeFee,
                downgradeFee: this.organisationDetail.downgradeFee,
                upgradeNoticeDays: this.organisationDetail.upgradeNoticeDays,
                downgradeNoticeDays: this.organisationDetail.downgradeNoticeDays,
                terminationNoticeDays: this.organisationDetail.terminationNoticeDays,
            });
        },
        saveInfoChanges() {

            if (this.organisationDetail.primaryColour === null) {
                this.organisationDetail.primaryColour = this.primaryColour;
            }
            if (this.organisationDetail.secondaryColour === null) {
                this.organisationDetail.secondaryColour = this.secondaryColour;
            }
            if (this.organisationDetail.navbarColour === null) {
                this.organisationDetail.navbarColour = this.navbarColour;
            }
            if (this.organisationDetail.navbarTextColour === null) {
                this.organisationDetail.navbarTextColour = this.navbarTextColour;
            }
            if (this.organisationDetail.orderPrimaryColour === null) {
                this.organisationDetail.orderPrimaryColour = this.orderPrimaryColour;
            } else if (this.organisationDetail.orderPrimaryColour.hex) {
                this.organisationDetail.orderPrimaryColour = this.organisationDetail.orderPrimaryColour.hex
            }
            if (this.organisationDetail.orderSecondaryColour === null) {
                this.organisationDetail.orderSecondaryColour = this.orderSecondaryColour;
            } else if (this.organisationDetail.orderSecondaryColour.hex) {
                this.organisationDetail.orderSecondaryColour = this.organisationDetail.orderSecondaryColour.hex
            }
            let item = this.organisationDetail
            item.accountingId = this.billingSettings.accountingId
            item.accountingSystem = this.billingSettings.accountingSystem
            item.aggregatePackageBilling = this.billingSettings.aggregatePackageBilling
            item.billIsp = this.billingSettings.billIsp
            item.billingDay = this.billingSettings.billingDay
            item.includeBillingDay = this.billingSettings.includeBillingDay
            item.installAccountCode = this.billingSettings.installAccountCode
            item.installFeeType = this.billingSettings.installFeeType
            item.packageAccount = this.billingSettings.packageAccount
            item.setupAccountCode = this.billingSettings.setupAccountCode
            item.setupFeeType = this.billingSettings.setupFeeType
            item.taxType = this.billingSettings.taxType


            delete item.allowedPaymentMethods
            if (item.allowedPaymentMethods) {
                // item.allowedPaymentMethods = JSON.stringify(item.allowedPaymentMethods)
            }
            if (typeof this.organisationDetail.primaryColour === "object") {
                this.organisationDetail.primaryColour = this.organisationDetail.primaryColour.hex;
            }
            if (typeof this.organisationDetail.secondaryColour === "object") {
                this.organisationDetail.secondaryColour = this.organisationDetail.secondaryColour.hex;
            }
            if (typeof this.organisationDetail.navbarColour === "object") {
                this.organisationDetail.navbarColour = this.organisationDetail.navbarColour.hex;
            }
            if (typeof this.organisationDetail.navbarTextColour === "object") {
                this.organisationDetail.navbarTextColour = this.organisationDetail.navbarTextColour.hex;
            }
            if (typeof this.organisationDetail.orderPrimaryColour === "object") {
                this.organisationDetail.orderPrimaryColour = this.organisationDetail.orderPrimaryColour.hex;
            }
            if (typeof this.organisationDetail.orderSecondaryColour === "object") {
                this.organisationDetail.orderSecondaryColour = this.organisationDetail.orderSecondaryColour.hex;
            }
            // delete item.logo
            // delete item.icon
            // delete item.packageCardModalImage
            // delete item.packageCardLogo
            // delete item.orderPageLogo
            

            Api()
                .put("/organisation/" + this.$store.state.currentOrg.org.id,
                    item)
                .then(async (response) => {
                    let organisations = this.$store.state.organisations;
                    let currentOrgId = this.$store.state.currentOrg.org.id;
                    let changedOrg = organisations.filter(function (el) {
                        return el.org.id === currentOrgId;
                    });
                    let index = organisations.indexOf(changedOrg[0]);
                    if (typeof this.organisationDetail.primaryColour === "object") {
                        this.organisationDetail.primaryColour = this.organisationDetail.primaryColour.hex;
                    }
                    if (typeof this.organisationDetail.secondaryColour === "object") {
                        this.organisationDetail.secondaryColour = this.organisationDetail.secondaryColour.hex;
                    }
                    if (typeof this.organisationDetail.navbarColour === "object") {
                        this.organisationDetail.navbarColour = this.organisationDetail.navbarColour.hex;
                    }
                    if (typeof this.organisationDetail.navbarTextColour === "object") {
                        this.organisationDetail.navbarTextColour = this.organisationDetail.navbarTextColour.hex;
                    }
                    if (typeof this.organisationDetail.orderPrimaryColour === "object") {
                        this.organisationDetail.orderPrimaryColour = this.organisationDetail.orderPrimaryColour.hex;
                    }
                    if (typeof this.organisationDetail.orderSecondaryColour === "object") {
                        this.organisationDetail.orderSecondaryColour = this.organisationDetail.orderSecondaryColour.hex;
                    }
                    let currentOrg = {
                        userType: this.$store.state.currentOrg.userType,
                        org: this.organisationDetail
                    };
                    organisations[index] = currentOrg;
                    await this.$store.dispatch("setOrganisations", organisations);
                    await this.$store.dispatch("setCurrentOrg", organisations[index]);
                });
        },
        displayContents(name) {
            return this.activeTabName === name;
        },
        setActiveTabName(name) {
            this.activeTabName = name;
            if (name == 'agreements') {
                this.headerTab = true
                this.footerTab = false
                this.documentTab = false
            }
        },
        initialize() {
            this.fetchOrganisationInfo();
            this.fetchOrganisationApiKeys();
            this.fetchAllContacts();
            this.fetchOrgContacts();
            this.fetchOrgUserRoles();
            this.fetchEmailTemplates("Reset Password");
            this.fetchInfo("Reset Password");
            this.fetchContactTypes();
            this.fetchAgreements();
            this.fetchBillingSettings()
            // if(this.organisationDetail&&this.organisationDetail.accountingSystem == 'Xero'){
            //   this.getXeroLoginUrl()
            //   if(this.$store.state.currentOrg.org.accountingId){
            //     this.fetchXeroAccounts()
            //     this.fetchXeroItems()
            //   }
            // }
        },
        fetchBillingSettings() {
            Api().get('/organisation/billingSettings').then(async res => {
                this.billingSettings = res.data
                console.log(this.billingSettings)
                if (this.billingSettings.accountingSystem == 'SageOne') {
                    this.fetchSageAccounts()
                    this.fetchSageItems()
                    this.fetchSageTaxTypes()
                } else if (this.billingSettings.accountingSystem == 'Xero') {
                    this.getXeroLoginUrl()
                    if (this.billingSettings.accountingId) {
                        this.getXeroTaxRates()
                        this.fetchXeroAccounts()
                        this.fetchXeroItems()
                    }

                }
            })
        },
        getXeroLoginUrl() {
            Api().get('/xero/authenticate').then(response => {
                if (response.data.url) {
                    this.xeroUrl = response.data.url
                    if (this.$route.query.code) {
                        this.getXeroTokens()
                    }
                } else if (response.data.tokenSet) {
                    this.xeroAuth = response.data.tokenSet
                    this.getXeroOrganisations()
                    this.getXeroTaxRates()
                    this.fetchXeroAccounts()
                    this.fetchXeroItems()
                }
            })
        },
        getXeroTokens() {
            Api().get('/xero/callback', {
                params: this.$route.query
            }).then(response => {
                if (response.data.tokenSet) {
                    this.xeroAuth = response.data.tokenSet
                    this.key += 1
                    this.getXeroOrganisations()
                    this.getXeroTaxRates()
                    this.fetchXeroAccounts()
                    this.fetchXeroItems()
                }
            })
        },
        getXeroOrganisations() {
            Api().get('/xero/getOrganisations').then(response => {
                this.accountingCompanies = response.data
            })
        },
        async fetchXeroAccounts() {
            await Api().get('/xero/accounts').then(res => {
                let result = res.data.body.accounts
                this.accountingAccounts = result.map(x => ({
                    id: x.code,
                    name: x.name
                }))
            })
        },
        async fetchXeroItems() {
            await Api().get('/xero/items').then(res => {
                let result = res.data.body.items

                this.accountingItems = result.map(x => ({
                    id: x.code,
                    name: x.name
                }))
            })
        },
        async fetchAgreements() {
            await Api()
                .get("/agreements")
                .then((response) => {
                    this.organisationAgreements = response.data;
                });
        },
        async fetchContactTypes() {
            if (this.$store.state.currentOrg.org.isPrimaryOrganisation == true) {
                Api()
                    .get("/contactTypes")
                    .then((response) => {
                        this.contactTypes = response.data;
                    });
            } else {
                Api()
                    .get("/contactTypes/activeIsp")
                    .then((response) => {
                        this.contactTypes = response.data;
                    });
            }
        },
        saveContact() {},
        removeContactFromOrg(item) {
            confirm(
                    "Are you sure you would like to remove this contact from the organisation?"
                ) &&
                Api()
                .put("/organisationContact/" + item.id, {
                    isActive: false,
                    isDeleted: true,
                })
                .then((response) => {
                    this.fetchOrganisationInfo();
                    this.fetchOrgContacts();
                });
        },
        fetchOrganisationApiKeys() {
            Api()
                .get("/organisationKeys")
                .then((response) => {
                    this.organisationKeys = response.data;
                    this.orgKey += 1;
                });
        },
        async saveNewContact() {
            await Api()
                .post("/contacts", {
                    name: this.contact.name,
                    surname: this.contact.surname,
                    idNumber: this.contact.idNumber,
                    mobileNumber: this.contact.mobileNumber,
                    telephoneNumber: this.contact.telephoneNumber,
                    emailAddress: this.contact.emailAddress,
                    password: this.contact.password,
                    isActive: true,
                })
                .then((response) => {
                    this.addOrganisationContact(response.data);
                });
        },
    },
};
</script>

<style>
.selectedBorder {
    background-color: #e6e6e6;
    border: 1px solid var(--primary);
    text-align: center;
}

.Planned {
    border-left: solid #d61212;
}

.Ongoing {
    border-left: 4px solid #eb780c;
}

.Complete {
    border-left: 4px solid #5eb110;
}

.Live {
    border-left: 4px solid #5eb110;
}

.my-editor {
    /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
    background: #fff;
    color: rgb(185, 185, 185);

    /* you must provide font-family font-size line-height. Example: */
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
    outline: none;
}

/* optional class for removing the outline */
/* .prism-editor__textarea:focus {
    outline: none;
  } */

.unlayer-editor {
    flex: 1;
    display: flex;
}

.unlayer-edit-editor {
    flex: 1;
    display: flex;
    transform: scale(0.90);
    transform-origin: left;
}

.compact-form-mdAndDown {
    transform: scale(0.90);
    transform-origin: left;
}

.compact-form-notMdAndDown {
    transform: scale(0.90);
    transform-origin: top;
}
</style>
